webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOADED_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NEXT_SCENE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MEET_CHECKPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NO_LIFE_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ENABLE_QUESTION_BOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DECREASE_LIFE; });
/* unused harmony export START_TIMER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return STOP_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return END_GAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ANSWERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TIMES_UP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Rx__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_Rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_Rx__);


/**
 * Created by Gaplo917 on 10/7/2017.
 */


// singleton

var EventHub = function () {
  function EventHub() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, EventHub);

    this.streams = {};
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(EventHub, [{
    key: "getEventStream",
    value: function getEventStream(eventName) {
      if (!this.streams[eventName]) {
        this.streams[eventName] = new __WEBPACK_IMPORTED_MODULE_2_rxjs_Rx___default.a.Subject();
      }

      return this.streams[eventName];
    }
  }, {
    key: "publishEvent",
    value: function publishEvent(eventName, data) {
      var stream = this.streams[eventName];
      if (stream) {
        stream.next(data);
      }
    }
  }]);

  return EventHub;
}();

var hub = new EventHub();
var LOAD_COMPLETE = "LOAD_COMPLETE";
var LOADED_FILE = "LOADED_FILE";
var NEXT_SCENE = "NEXT_SCENE";
var MEET_CHECKPOINT = "MEET_CHECKPOINT";
var NO_LIFE_LEFT = "NO_LIFE_LEFT";
var ENABLE_QUESTION_BOX = "ENABLE_QUESTION_BOX";
var DECREASE_LIFE = "DECREASE_LIFE";
var START_TIMER = "START_TIMER";
var STOP_TIMER = "STOP_TIMER";
var END_GAME = "END_GAME";

var ANSWERED = 'ANSWERED';
var TIMES_UP = "TIMES_UP";

/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var Component = __webpack_require__(373)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(1072),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1071:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1072:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pixel-loader"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_R__ = __webpack_require__(5);




/**
 * Created by Gaplo917 on 9/7/2017.
 */



var Image = function (_PIXI$Sprite) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Image, _PIXI$Sprite);

  function Image(x, y, texture) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Image);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Image.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Image)).call(this, texture));

    _this.anchor.x = 0.5;
    _this.anchor.y = 0.5;
    _this.x = x;
    _this.y = y;
    return _this;
  }

  return Image;
}(__WEBPACK_IMPORTED_MODULE_4_pixi_js__["Sprite"]);

/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BannerText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_R__ = __webpack_require__(5);





/**
 * Created by Gaplo917 on 5/9/2017.
 */




var BannerText = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BannerText, _PIXI$Container);

  function BannerText(x, y) {
    var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var resources = arguments[3];

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BannerText);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BannerText.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(BannerText)).call(this));

    _this.x = x;
    _this.y = y;
    var textStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["TextStyle"](__WEBPACK_IMPORTED_MODULE_7__config_R__["a" /* default */].textStyles.chinese(70)), {
      stroke: '#fff',
      fill: '#000',
      dropShadowColor: '#ffffff',
      dropShadow: true,
      dropShadowBlur: 40,
      dropShadowAngle: 0,
      dropShadowDistance: 0,
      strokeThickness: 10,
      lineJoin: 'round',
      padding: 100

      //const questionBox = new PIXI.Sprite(resources[R.images.questionBox.name].texture)
      //questionBox.anchor.x = 0.5
      //questionBox.anchor.y = 0.5

    });var text3 = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["Text"](text, textStyle);
    // text3.x = -50
    // text3.anchor.x = 0.5
    // text3.anchor.y = 0.5

    //this.addChild(questionBox)
    _this.addChild(text3);
    _this.text3 = text3;
    return _this;
  }

  return BannerText;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Man; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var Man = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Man, _PIXI$Container);

  function Man(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Man);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Man.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Man)).call(this));

    _this.x = x;
    _this.y = y;

    var man = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man);

    _this.man = man;

    _this.addChild(man);
    _this.normal();

    _this.isLoseAndHoldPos = false;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Man, [{
    key: 'removeAllChild',
    value: function removeAllChild() {
      __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.remove(this.winkingTween);
      __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.remove(this._tween);
      this.removeChildren();
    }
  }, {
    key: 'pickingUp',
    value: function pickingUp(stage, map) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        requestAnimationFrame(function () {
          stage.removeChild(map);
        });
        _this2.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.pickingUp, false, function () {
          _this2.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.jump, true, function () {
            obs.next();
            obs.complete();
          });
        });
      });
    }
  }, {
    key: 'endGameStop',
    value: function endGameStop() {
      this.man.stopAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.jump, false);
    }
  }, {
    key: 'endGameWalking',
    value: function endGameWalking() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this3.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.walking, true);

        _this3._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this3).to({ x: "+1200" }, 3000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {
          obs.next();
          obs.complete();
        }).start();
      });
    }
  }, {
    key: 'walking',
    value: function walking() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this4.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.walking, true);

        _this4._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this4).to({ x: 2500 }, 4000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {
          obs.next();
          obs.complete();
        }).start();
      });
    }
  }, {
    key: 'rideOnCamel',
    value: function rideOnCamel(camel, onComplete) {

      this.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.ride, true);
      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ x: camel.x + 50, y: "-80" }, 500).onComplete(function () {
        onComplete();
      }).start();
    }
  }, {
    key: 'normal',
    value: function normal() {
      this.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.winking, true);
    }
  }, {
    key: 'onFire',
    value: function onFire() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_10__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_10__Events__["e" /* DECREASE_LIFE */], {});
      this.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.hitOnFire, false, function () {
        if (!_this5.isLoseAndHoldPos) {
          _this5.normal();
        } else {
          _this5.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.hitOnFire, true);
        }
      });
    }
  }, {
    key: 'unhappy',
    value: function unhappy() {
      var _this6 = this;

      this.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.hitByBow, false, function () {
        if (!_this6.isLoseAndHoldPos) {
          _this6.normal();
        } else {
          _this6.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.hitByBow, true);
        }
      });
    }
  }, {
    key: 'onShoot',
    value: function onShoot() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_10__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_10__Events__["e" /* DECREASE_LIFE */], {});
      this.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.hitByBow, false, function () {
        if (!_this7.isLoseAndHoldPos) {
          _this7.normal();
        } else {
          _this7.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.hitByBow, true);
        }
      });
    }
  }, {
    key: 'getRollByStone',
    value: function getRollByStone() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_10__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_10__Events__["e" /* DECREASE_LIFE */], {});
      this.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.hitByStone, false, function () {
        if (!_this8.isLoseAndHoldPos) {
          _this8.normal();
        } else {
          _this8.man.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.man.animations.hitByStone, true);
        }
      });
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this9 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this9.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this9.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Man;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__objects_Scene__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_FullScreenOverlay__ = __webpack_require__(408);




/**
 * Created by Gaplo917 on 9/7/2017.
 */






var InfoScene = function (_Scene) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(InfoScene, _Scene);

  function InfoScene(resources, texture) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InfoScene);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InfoScene.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(InfoScene)).call(this));

    var tutorialBg = new __WEBPACK_IMPORTED_MODULE_8__objects_FullScreenOverlay__["a" /* default */](0xffffff, 0.4);
    var msg = new __WEBPACK_IMPORTED_MODULE_7__objects_Image__["a" /* default */](0, 0, texture);

    // switch(level){
    //   case 1 :
    //     if (status === 'success')
    //       this.msg = new Image(0, 0, resources[R.images.success_01.name].texture)
    //     else
    //       this.msg = new Image(0, 0, resources[R.images.fail_01.name].texture)
    //     break
    //   case 2 :
    //     if (status === 'success')
    //       this.msg = new Image(0, 0, resources[R.images.success_02.name].texture)
    //     else
    //       this.msg = new Image(0, 0, resources[R.images.fail_02.name].texture)
    //     break
    //   case 3 :
    //     if (status === 'success')
    //       this.msg = new Image(0, 0, resources[R.images.success_03.name].texture)
    //     else
    //       this.msg = new Image(0, 0, resources[R.images.fail_03.name].texture)
    //     break
    // }

    msg.x = tutorialBg.width / 2;
    msg.y = tutorialBg.height / 2;

    _this.displayGroup = new __WEBPACK_IMPORTED_MODULE_4_pixi_js__["DisplayGroup"](10, true);
    _this.interactive = false;
    _this.buttonMode = false;

    _this.addChild(tutorialBg);
    _this.addChild(msg);
    return _this;
  }

  return InfoScene;
}(__WEBPACK_IMPORTED_MODULE_6__objects_Scene__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (InfoScene);

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export degToRadian */
/* unused harmony export getInternetExplorerVersion */
/* harmony export (immutable) */ __webpack_exports__["b"] = isIE11;
/* unused harmony export randomInt */
/* unused harmony export keyboard */
/* unused harmony export hitObjects */
/* unused harmony export contain */
/* harmony export (immutable) */ __webpack_exports__["a"] = getQueryVariable;
/* unused harmony export randomIntFromInterval */
/**
 * Created by Gaplo917 on 8/7/2017.
 */

function degToRadian(deg) {
  return deg / 180 * Math.PI;
}

function getInternetExplorerVersion() {
  var rv = -1;
  if (navigator.appName === 'Microsoft Internet Explorer') {
    var ua = navigator.userAgent;
    var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
    if (re.exec(ua) !== null) rv = parseFloat(RegExp.$1);
  } else if (navigator.appName === 'Netscape') {
    var _ua = navigator.userAgent;
    var _re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
    if (_re.exec(_ua) !== null) rv = parseFloat(RegExp.$1);
  }
  return rv;
}

function isIE11() {
  return getInternetExplorerVersion() === 11;
}

// random Int
function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

//The `keyboard` helper function
function keyboard(keyCode) {
  var key = {};
  key.code = keyCode;
  key.isDown = false;
  key.isUp = true;
  key.press = undefined;
  key.release = undefined;
  //The `downHandler`
  key.downHandler = function (event) {
    if (event.keyCode === key.code) {
      if (key.isUp && key.press) key.press();
      key.isDown = true;
      key.isUp = false;
    }
    event.preventDefault();
  };

  //The `upHandler`
  key.upHandler = function (event) {
    if (event.keyCode === key.code) {
      if (key.isDown && key.release) key.release();
      key.isDown = false;
      key.isUp = true;
    }
    event.preventDefault();
  };

  //Attach event listeners
  window.addEventListener('keydown', key.downHandler, false);
  window.addEventListener('keyup', key.upHandler, false);
  return key;
}

function hitObjects(r1, r2) {

  //Define the variables we'll need to calculate
  var hit = void 0,
      combinedHalfWidths = void 0,
      combinedHalfHeights = void 0,
      vx = void 0,
      vy = void 0;

  //hit will determine whether there's a collision
  hit = false;

  //Find the center points of each sprite
  r1.centerX = r1.x + r1.width / 2;
  r1.centerY = r1.y + r1.height / 2;
  r2.centerX = r2.x + r2.width / 2;
  r2.centerY = r2.y + r2.height / 2;

  //Find the half-widths and half-heights of each sprite
  r1.halfWidth = r1.width / 2;
  r1.halfHeight = r1.height / 2;
  r2.halfWidth = r2.width / 2;
  r2.halfHeight = r2.height / 2;

  //Calculate the distance vector between the sprites
  vx = r1.centerX - r2.centerX;
  vy = r1.centerY - r2.centerY;

  //Figure out the combined half-widths and half-heights
  combinedHalfWidths = r1.halfWidth + r2.halfWidth;
  combinedHalfHeights = r1.halfHeight + r2.halfHeight;

  //Check for a collision on the x axis
  if (Math.abs(vx) < combinedHalfWidths) {
    //A collision might be occuring. Check for a collision on the y axis
    if (Math.abs(vy) < combinedHalfHeights) {
      //There's definitely a collision happening
      hit = true;
    } else {
      //There's no collision on the y axis
      hit = false;
    }
  } else {
    //There's no collision on the x axis
    hit = false;
  }
  //`hit` will be either `true` or `false`
  return hit;
};

// get the latest collision position
function contain(sprite, container) {

  var collision = 'inScreen';
  //let collision = undefined;

  //Left
  if (sprite.x < container.x) {
    sprite.x = container.x;
    collision = 'left';
  }

  //Top
  if (sprite.y < container.y) {
    sprite.y = container.y;
    collision = 'top';
  }

  //Right
  if (sprite.x + sprite.width > container.width) {
    sprite.x = container.width - sprite.width;
    collision = 'right';
  }

  //Bottom
  if (sprite.y + sprite.height > container.height) {
    sprite.y = container.height - sprite.height;
    collision = 'bottom';
  }

  //Return the `collision` value
  return collision;
}

function getQueryVariable(variable) {
  var query = window.location.href;
  if (query == "" || !query || query.indexOf('?') == -1) return "";
  var vars = decodeURIComponent(query).split('?')[1].split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  console.log('Query variable %s not found', variable);
}

function randomIntFromInterval(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CreateJsSound */
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GameUtils__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Events__ = __webpack_require__(10);


/**
 * Created by Gaplo917 on 15/7/2017.
 * Wrapper for howler
 * https://github.com/goldfire/howler.js#documentation
 */




var CreateJsSound = function () {
  function CreateJsSound(_ref) {
    var id = _ref.id,
        volume = _ref.volume,
        loop = _ref.loop;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CreateJsSound);

    this.id = id;
    this.volume = volume;
    // createjs Sound using loop count instead of loop boolean, 100000 should be more than enough for infinity loop
    this.loop = loop ? 100000 : 0;
    this.instance = null;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CreateJsSound, [{
    key: "play",
    value: function play(onComplete) {
      var _this = this;

      console.log("playing " + this.id + " with volume " + this.volume);
      if (__WEBPACK_IMPORTED_MODULE_2__GameUtils__["b" /* isIE11 */]()) {
        if (createjs.Sound.loadComplete(this.id)) {
          this.instance = createjs.Sound.play(this.id, { loop: this.loop });
          this.instance.volume = this.volume;

          if (typeof onComplete === 'function') {
            this.instance.on('complete', function () {
              return onComplete();
            });
          }
        } else {
          createjs.Sound.registerSound(this.id, this.id, 2);
          __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].interval(16).filter(function () {
            return createjs.Sound.loadComplete(_this.id);
          }).take(1).takeUntil(__WEBPACK_IMPORTED_MODULE_4__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_4__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
            _this.instance = createjs.Sound.play(_this.id, { loop: _this.loop });
            _this.instance.volume = _this.volume;

            if (typeof onComplete === 'function') {
              _this.instance.on('complete', function () {
                return onComplete();
              });
            }
          });
        }
      } else {

        this.instance = createjs.Sound.play(this.id, { loop: this.loop });
        this.instance.volume = this.volume;

        if (typeof onComplete === 'function') {
          this.instance.on('complete', function () {
            return onComplete();
          });
        }
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.instance) {
        this.instance.stop();
      }
    }
  }]);

  return CreateJsSound;
}();

function create(opt) {
  var src = Array.isArray(opt.src) ? opt.src[0] : opt.src;
  var id = src; // use src as Id
  var volume = opt.volume;
  var loop = opt.loop || false;
  return new CreateJsSound({ id: id, volume: volume, loop: loop });
}

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckPointArrow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var CheckPointArrow = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CheckPointArrow, _PIXI$Container);

  function CheckPointArrow(x, y, rotation, texture) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CheckPointArrow);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CheckPointArrow.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CheckPointArrow)).call(this));

    _this.x = x;
    _this.y = y;

    var arrow = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, texture);
    _this.arrow = arrow;

    _this.addChild(arrow);

    _this.pivot.x = _this.width / 2;
    _this.pivot.y = _this.height / 2;
    _this.rotation = rotation;
    _this.alpha = 0;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CheckPointArrow, [{
    key: 'flashing',
    value: function flashing() {
      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ alpha: 1 }, 500).repeat(8).yoyo(true).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {}).start();
    }
  }, {
    key: 'remove',
    value: function remove() {
      this.destroy();
    }
  }]);

  return CheckPointArrow;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Door; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var Door = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Door, _PIXI$Container);

  function Door(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Door);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Door.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Door)).call(this));

    _this.x = x;
    _this.y = y;

    var door01 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.door_01.name].texture);
    var door02 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.door_02.name].texture);

    door02.displayGroup = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["DisplayGroup"](2, true);
    door01.displayGroup = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["DisplayGroup"](4, true);

    _this.addChild(door01);
    _this.addChild(door02);

    _this.alpha = 0;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Door, [{
    key: 'appear',
    value: function appear() {
      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ alpha: 1 }, 500).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {}).start();
    }
  }, {
    key: 'appearing',
    value: function appearing() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ alpha: 1 }, 500).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {
          obs.next();
          obs.complete();
        }).start();
      });
    }
  }]);

  return Door;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Button__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_Image__ = __webpack_require__(12);












var Heart = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Heart, _PIXI$Container);

  function Heart(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Heart);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Heart.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Heart)).call(this));

    _this.x = x;
    _this.y = y;

    var heartTexture = resources[__WEBPACK_IMPORTED_MODULE_7__config_R__["a" /* default */].images.heart.name].texture;
    var heartHollowedTexture = resources[__WEBPACK_IMPORTED_MODULE_7__config_R__["a" /* default */].images.heartEmpty.name].texture;
    var heart = new __WEBPACK_IMPORTED_MODULE_10__objects_Image__["a" /* default */](0, 0, heartTexture);
    var heartHollowed = new __WEBPACK_IMPORTED_MODULE_10__objects_Image__["a" /* default */](0, 0, heartHollowedTexture);

    _this.addChild(heart);

    _this.heart = heart;
    _this.heartHollowed = heartHollowed;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Heart, [{
    key: "setHollow",
    value: function setHollow(bool) {
      this.removeChildren();
      if (bool) {
        this.addChild(this.heartHollowed);
      } else {
        this.addChild(this.heart);
      }
    }
  }]);

  return Heart;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/* harmony default export */ __webpack_exports__["a"] = (Heart);

/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_Button__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__objects_CustomMultiStyleText__ = __webpack_require__(407);














var QuestionBox = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(QuestionBox, _PIXI$Container);

  function QuestionBox(x, y, questions, resources, level) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, QuestionBox);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (QuestionBox.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(QuestionBox)).call(this));

    _this.x = x;
    _this.y = y;

    _this.questionIndex = 0;
    _this.questions = questions;

    _this.fontColor = "";

    switch (level) {
      case "level1":
        _this.fontColor = '#000';
        _this.questionBox1 = new __WEBPACK_IMPORTED_MODULE_10__objects_Button__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.level1Choice1.name].texture, false);
        _this.questionBox2 = new __WEBPACK_IMPORTED_MODULE_10__objects_Button__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.level1Choice2.name].texture, false);
        break;
      case "level2":
        _this.fontColor = '#006ebf';
        _this.questionBox1 = new __WEBPACK_IMPORTED_MODULE_10__objects_Button__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.level2Choice1.name].texture, false);
        _this.questionBox2 = new __WEBPACK_IMPORTED_MODULE_10__objects_Button__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.level2Choice2.name].texture, false);
        break;
      case "level3":
        _this.fontColor = '#006ebf';
        _this.questionBox1 = new __WEBPACK_IMPORTED_MODULE_10__objects_Button__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.level3Choice1.name].texture, false);
        _this.questionBox2 = new __WEBPACK_IMPORTED_MODULE_10__objects_Button__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.level3Choice2.name].texture, false);
        break;
    }

    // console.log("fontColor", this.fontColor)

    var wordStyle = new __WEBPACK_IMPORTED_MODULE_7_pixi_js__["TextStyle"](__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].textStyles.chinese(70), {
      wordWrap: true,
      wordWrapWidth: 500,
      breakWords: true,
      fill: _this.fontColor
    }));
    var yiStyle = new __WEBPACK_IMPORTED_MODULE_7_pixi_js__["TextStyle"](__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].textStyles.chinese(55), {
      wordWrap: true,
      wordWrapWidth: 500,
      breakWords: true,
      fill: _this.fontColor
    }));

    _this.choice1 = new __WEBPACK_IMPORTED_MODULE_12__objects_CustomMultiStyleText__["a" /* CustomMultiStyleText */]('', {
      "default": __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, wordStyle, {
        stroke: '#fff',
        fill: _this.fontColor,
        dropShadowColor: '#ffffff',
        dropShadow: true,
        dropShadowBlur: 20,
        dropShadowAngle: 0,
        dropShadowDistance: 0,
        strokeThickness: 10,
        lineJoin: 'round',
        lineSpace: 1.2,
        trim: true
      }),
      "yi": __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, yiStyle)
    });
    _this.choice1.anchor.x = 0.5;
    _this.choice1.anchor.y = 0.5;

    _this.choice2 = new __WEBPACK_IMPORTED_MODULE_12__objects_CustomMultiStyleText__["a" /* CustomMultiStyleText */]('', {
      "default": __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, wordStyle, {
        stroke: '#fff',
        fill: _this.fontColor,
        dropShadowColor: '#ffffff',
        dropShadow: true,
        dropShadowBlur: 20,
        dropShadowAngle: 0,
        dropShadowDistance: 0,
        strokeThickness: 10,
        lineJoin: 'round',
        lineSpace: 1.2,
        trim: true
      }),
      "yi": __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, yiStyle, {
        fill: _this.fontColor
      })
    });
    _this.choice2.anchor.x = 0.5;
    _this.choice2.anchor.y = 0.5;

    _this.answer = '';

    var container1 = new __WEBPACK_IMPORTED_MODULE_7_pixi_js__["Container"]();
    var container2 = new __WEBPACK_IMPORTED_MODULE_7_pixi_js__["Container"]();

    _this.questionBox1.addOnClickListener(function () {
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["f" /* ANSWERED */], { choice: _this.choice1.text, answer: _this.answer });
    });

    _this.questionBox2.addOnClickListener(function () {
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["f" /* ANSWERED */], { choice: _this.choice2.text, answer: _this.answer });
    });

    _this.invisible();

    container1.addChild(_this.questionBox1);
    container1.addChild(_this.choice1);

    container2.addChild(_this.questionBox2);
    container2.addChild(_this.choice2);

    container1.x = 0;
    container1.y = 500;

    container2.x = 800;
    container2.y = 500;

    _this.addChild(container1);
    _this.addChild(container2);

    _this.nextQuestion();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(QuestionBox, [{
    key: "nextQuestion",
    value: function nextQuestion() {
      console.log('questionIndex:' + this.questionIndex);
      var question = this.questions[this.questionIndex];

      // works as long as not more than 2 line
      var exptecedWrappedText1 = this.choice1.wordWrap(question.choice1);
      if (exptecedWrappedText1.endsWith("\n。") || exptecedWrappedText1.endsWith("\n！")) {
        this.choice1._style.wordWrap = false;
        this.choice1._style.breakWords = false;
      } else {
        this.choice1._style.wordWrap = true;
        this.choice1._style.breakWords = true;
      }

      // works as long as not more than 2 line
      var exptecedWrappedText2 = this.choice2.wordWrap(question.choice2);
      if (exptecedWrappedText2.endsWith("\n。") || exptecedWrappedText2.endsWith("\n！")) {
        this.choice2._style.wordWrap = false;
        this.choice2._style.breakWords = false;
      } else {
        this.choice2._style.wordWrap = true;
        this.choice2._style.breakWords = true;
      }

      this.choice1.text = question.choice1;
      this.choice2.text = question.choice2;
      this.answer = question.answer;

      this.questionIndex = this.questionIndex + 1;
    }
  }, {
    key: "textWithoutMarkUp",
    value: function textWithoutMarkUp(multilineText, str) {
      var result = '';
      var tags = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(multilineText.textStyles).join("|");
      var re = new RegExp("(</?(" + tags + ")>)", "g");
      var parts = str.split(re);
      for (var k = 0; k < parts.length; k++) {
        if (re.test(parts[k])) {
          if (parts[k][1] === "/") {
            k++;
          } else {
            k++;
          }
        } else {
          result += parts[k];
        }
      }
      return result;
    }
  }, {
    key: "isLastQuestion",
    value: function isLastQuestion() {
      // disable the onclick question box 1 and box 2 when it is a last question
      if (this.questionIndex >= this.questions.length) {
        this.questionBox1.removeOnClickListener();
        this.questionBox2.removeOnClickListener();
      }
      return this.questionIndex >= this.questions.length;
    }
  }, {
    key: "invisible",
    value: function invisible() {
      this.alpha = 0;
      this.questionBox1.interactive = false;
      this.questionBox2.interactive = false;
    }
  }, {
    key: "disableQuestionBox",
    value: function disableQuestionBox() {
      var _this2 = this;

      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.questionBox1.interactive = false;
      this.questionBox2.interactive = false;

      if (!opt.isVisible) {
        this._tween = new __WEBPACK_IMPORTED_MODULE_8__tweenjs_tween_js___default.a.Tween(this).to({ alpha: 0 }, 1000)
        //.easing(this.createNoisyEasing(0.3,TWEEN.Easing.Quartic.In))
        .easing(__WEBPACK_IMPORTED_MODULE_8__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {
          if (!_this2.isLastQuestion()) _this2.nextQuestion();
        }).start();
      }
    }
  }, {
    key: "enableQuestionBox",
    value: function enableQuestionBox() {
      this.visible = true;
      this.questionBox1.interactive = true;
      this.questionBox2.interactive = true;

      this._tween = new __WEBPACK_IMPORTED_MODULE_8__tweenjs_tween_js___default.a.Tween(this).to({ alpha: 1 }, 1000)
      //.easing(this.createNoisyEasing(0.3,TWEEN.Easing.Quartic.In))
      .easing(__WEBPACK_IMPORTED_MODULE_8__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {}).start();
    }
  }]);

  return QuestionBox;
}(__WEBPACK_IMPORTED_MODULE_7_pixi_js__["Container"]);

/* harmony default export */ __webpack_exports__["a"] = (QuestionBox);

/***/ }),

/***/ 169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpeechBubble; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var SpeechBubble = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SpeechBubble, _PIXI$Container);

  function SpeechBubble(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SpeechBubble);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SpeechBubble.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SpeechBubble)).call(this));

    _this.x = x;
    _this.y = y;

    var bubble = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.speechBubble.name].texture);
    var key = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, -20, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.key.name].texture);

    _this.addChild(bubble);
    _this.addChild(key);

    _this.alpha = 0;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SpeechBubble, [{
    key: 'disappear',
    value: function disappear() {
      return new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).delay(2000).to({ alpha: 0 }, 500).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.InOut).onComplete(function () {});
    }
  }, {
    key: 'appear',
    value: function appear() {
      return new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ alpha: 1 }, 500).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.InOut).onComplete(function () {
        __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.click1);
      });
    }
  }]);

  return SpeechBubble;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Timer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SoundManager__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__tweenjs_tween_js__);














var TOTAL_CORRECT_QUESTIONS = __WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].settings.common.totalCorrectQuestions;

var Timer = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Timer, _PIXI$Container);

  function Timer(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Timer);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Timer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Timer)).call(this));

    _this.x = x;
    _this.y = y;

    var bg = new __WEBPACK_IMPORTED_MODULE_10__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].images.timerBox.name].texture);
    var textStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, new __WEBPACK_IMPORTED_MODULE_6_pixi_js__["TextStyle"](__WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].textStyles.timer(60)), {
      fill: '#ffffff'
    });

    var textContainer = new __WEBPACK_IMPORTED_MODULE_6_pixi_js__["Text"]('0/' + TOTAL_CORRECT_QUESTIONS, textStyle);

    textContainer.anchor.x = 0.5;
    textContainer.anchor.y = 0.5;

    _this.addChild(bg);
    _this.addChild(textContainer);

    _this.textContainer = textContainer;

    _this.score = 0;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Timer, [{
    key: 'addScore',
    value: function addScore() {
      this.score += 1;
      this.textContainer.text = this.score + '/' + TOTAL_CORRECT_QUESTIONS;
    }
  }, {
    key: 'flashing',
    value: function flashing() {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_12__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].sounds.d, function () {
          __WEBPACK_IMPORTED_MODULE_12__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].sounds.d, function () {
            __WEBPACK_IMPORTED_MODULE_12__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].sounds.d);
          });
        });
      }, 1000);
      return new __WEBPACK_IMPORTED_MODULE_13__tweenjs_tween_js___default.a.Tween(this).delay(4500);
    }
  }]);

  return Timer;
}(__WEBPACK_IMPORTED_MODULE_6_pixi_js__["Container"]);

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Events__ = __webpack_require__(10);




var LifeBarController = function () {
  function LifeBarController(hearts, initialLife) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LifeBarController);

    this.hearts = hearts;
    this.initalLife = initialLife;
    this.currentLife = initialLife;
    this.setLife(initialLife);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LifeBarController, [{
    key: 'setLife',
    value: function setLife(life) {
      for (var i = 0; i < this.hearts.length; i++) {
        if (i < life) {
          this.hearts[i].setHollow(false);
        } else {
          this.hearts[i].setHollow(true);
        }
      }
    }
  }, {
    key: 'decrement',
    value: function decrement() {
      this.currentLife--;

      this.setLife(this.currentLife);

      if (this.currentLife === 0) {
        __WEBPACK_IMPORTED_MODULE_2__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_2__Events__["g" /* NO_LIFE_LEFT */]);
      } else {
        __WEBPACK_IMPORTED_MODULE_2__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_2__Events__["j" /* ENABLE_QUESTION_BOX */], {});
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.currentLife = this.initalLife;

      this.setLife(this.currentLife);
    }
  }]);

  return LifeBarController;
}();

/* harmony default export */ __webpack_exports__["a"] = (LifeBarController);

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Events__ = __webpack_require__(10);







var QuestionController = function () {
  function QuestionController(levelSetting) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, QuestionController);

    this.level = levelSetting.level;
    this.questions = [];
    this.totalCorrect = 0;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(QuestionController, [{
    key: "prepareQuestions",
    value: function prepareQuestions() {
      // select 12 questions randomly
      this.questions = __WEBPACK_IMPORTED_MODULE_3_lodash__["shuffle"](__WEBPACK_IMPORTED_MODULE_4__config_R__["a" /* default */].question[this.level]).slice(0, __WEBPACK_IMPORTED_MODULE_4__config_R__["a" /* default */].settings.common.totalQuestions);
    }
  }, {
    key: "isCorrect",
    value: function isCorrect(selectedChoice, answer) {
      if (selectedChoice === answer) this.totalCorrect = this.totalCorrect + 1;
      return selectedChoice === answer;
      // this.totalCorrect = this.totalCorrect + 1
      // return true
    }
  }, {
    key: "isMeetCheckPoint",
    value: function isMeetCheckPoint() {
      var isMeetCP = this.totalCorrect !== 0 && this.totalCorrect % 3 === 0;
      if (isMeetCP) {
        __WEBPACK_IMPORTED_MODULE_5__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_5__Events__["i" /* MEET_CHECKPOINT */]);
        this.totalCorrect = 0;
      }
      return isMeetCP;
    }
  }]);

  return QuestionController;
}();

/* harmony default export */ __webpack_exports__["a"] = (QuestionController);

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationUtils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js__);



/**
 * Created by Gaplo917 on 23/8/2017.
 */


function _fade(displayObject, _ref) {
  var alpha = _ref.alpha,
      duration = _ref.duration,
      delay = _ref.delay;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    new __WEBPACK_IMPORTED_MODULE_3__tweenjs_tween_js___default.a.Tween(displayObject).delay(delay).to({ alpha: alpha }, duration).onComplete(function () {
      resolve();
    }).start();
  });
}

var AnimationUtils = function () {
  function AnimationUtils() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimationUtils);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimationUtils, null, [{
    key: "fadeIn",
    value: function fadeIn(displayObject) {
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _alpha = opt.alpha || 1;
      var _duration = opt.duration || 1000;
      var _delay = opt.delay || 0;
      return _fade(displayObject, { alpha: _alpha, duration: _duration, delay: _delay });
    }
  }, {
    key: "fadeOut",
    value: function fadeOut(displayObject) {
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _alpha = opt.alpha || 0;
      var _duration = opt.duration || 1000;
      var _delay = opt.delay || 0;

      return _fade(displayObject, { alpha: _alpha, duration: _duration, delay: _delay });
    }
  }]);

  return AnimationUtils;
}();

/***/ }),

/***/ 23:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);





/**
 * Created by Gaplo917 on 15/8/2017.
 */



function loadSpriteSheetsTextures(resources, config) {
  if (Array.isArray(config.json)) {
    return __WEBPACK_IMPORTED_MODULE_6_lodash__["flatMapDeep"](config.json.map(function (any, i) {
      return __WEBPACK_IMPORTED_MODULE_6_lodash__["values"](resources[config.id + "-" + i].textures);
    }));
  } else {
    return __WEBPACK_IMPORTED_MODULE_6_lodash__["values"](resources[config.id].textures);
  }
}

var CustomAnimatedSprite = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CustomAnimatedSprite, _PIXI$Container);

  /**
   * @param x
   * @param y
   * @param resources
   * @param config SpriteSheet Config
   * SpriteSheet Config Sample
   *
   * hedgehogAll: {
   *    id: 'hedgehog_all.png',
   *    json: ['static/spritesheet/hedgehog_all-0.json', 'static/spritesheet/hedgehog_all-1.json'],
   *    animationSpeed: 0.2,
   *    animations: {
   *      // key : 'prefix of images'
   *      effect1: 'hedgehog_effect01',
   *      effect2: 'hedgehog_effect02',
   *      effect3: 'hedgehog_effect03',
   *      effect4: 'hedgehog_effect04',
   *      effect5: 'hedgehog_effect05',
   *      effect7: 'hedgehog_effect07',
   *      effect8: 'hedgehog_effect08',
   *      effectIdle: 'hedgehog_effect_idle',
   *      effectRolling: 'hedgehog_effect_rolling',
   *    }
   *  },
   */
  function CustomAnimatedSprite(x, y, resources, config) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CustomAnimatedSprite);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CustomAnimatedSprite.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CustomAnimatedSprite)).call(this));

    if (config.id && resources[config.id] && resources[config.id].spineData) {
      _this.isSpine = true;
      var spine = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["spine"].Spine(resources[config.id].spineData);

      spine.state.timeScale = config.timeScale || 1.0;

      var localRect = spine.getLocalBounds();
      spine.position.set(-localRect.x / 2, -localRect.y / 2);
      spine.state.setEmptyAnimations();
      _this._spine = spine;

      _this.addChild(spine);
    } else {
      _this.isSpine = false;
      // by design in BaseGame.loadImages, `resources[R.spriteSheets.xxx.id].textures` return the frames key-value arrays
      // need to flatten it and sort it
      var textures = __WEBPACK_IMPORTED_MODULE_6_lodash__["sortBy"](loadSpriteSheetsTextures(resources, config), function (a, b) {
        return a.textureCacheIds[0];
      });

      var animatedSprites = {};

      __WEBPACK_IMPORTED_MODULE_6_lodash__["each"](config.animations, function (prefix) {
        var targetTextures = textures.filter(function (t) {
          return t.textureCacheIds[0].startsWith(prefix);
        });

        var animatedSprite = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["extras"].AnimatedSprite(targetTextures);

        animatedSprite.animationSpeed = config.animationSpeed;
        animatedSprite.x = 0;
        animatedSprite.y = 0;
        animatedSprite.anchor.x = 0.5;
        animatedSprite.anchor.y = 0.5;

        animatedSprites[prefix] = animatedSprite;
      });

      _this.textures = textures;
      _this.animatedSprites = animatedSprites;
    }

    _this.x = x;
    _this.y = y;
    _this.config = config;
    return _this;
  }

  /**
   * @returns {PIXI.spine.Spine | *}
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CustomAnimatedSprite, [{
    key: "frameAt",
    value: function frameAt(index) {
      if (this.isSpine) throw new Error("Spine not support frameAt function");
      return this.textures[index];
    }
  }, {
    key: "_stopAllAnimation",
    value: function _stopAllAnimation() {
      if (this.isSpine) {
        // nothing needed
      } else {
        __WEBPACK_IMPORTED_MODULE_6_lodash__["each"](this.animatedSprites, function (as) {
          as.stop();
        });
      }

      this.removeChildren();
    }
  }, {
    key: "stopAnimation",
    value: function stopAnimation(prefix) {
      var removeFromContainer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (this.isSpine) {
        var spine = this._spine;
        spine.state.clearTracks();

        if (removeFromContainer) {
          this.removeChild(this._spine);
        }
      } else {
        var animatedSprite = this.animatedSprites[prefix];
        animatedSprite.stop();

        if (removeFromContainer) {
          this.removeChild(animatedSprite);
        }
      }
    }
  }, {
    key: "playAnimation",
    value: function playAnimation(prefix) {
      var loop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var onComplete = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};


      if (this.isSpine) {
        var spine = this._spine;
        var trackIndex = prefix.track || 0;
        var animationName = prefix.name || prefix;

        if (spine.state.hasAnimation(animationName)) {
          requestAnimationFrame(function () {
            spine.state.setAnimation(trackIndex, animationName, loop);
            spine.state.tracks[trackIndex].listener = {
              complete: onComplete
            };
          });
        } else {
          console.warn("No animation with " + prefix + " in " + this.config + " ");
          onComplete();
        }
      } else {
        // stop all animation first
        this._stopAllAnimation();

        var animatedSprite = this.animatedSprites[prefix];
        this.addChild(animatedSprite);

        console.log("play animation repeat " + loop, animatedSprite);
        animatedSprite.loop = loop;

        animatedSprite.onComplete = onComplete;

        // start the animation
        requestAnimationFrame(function () {
          animatedSprite.gotoAndPlay(0);
        });
      }
    }
  }, {
    key: "spine",
    get: function get() {
      return this._spine;
    }
  }]);

  return CustomAnimatedSprite;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/* harmony default export */ __webpack_exports__["a"] = (CustomAnimatedSprite);

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SoundManager__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BaseGame__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SoundUtils__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Scene1__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Scene2__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__scenes_index__ = __webpack_require__(415);





/**
 * Created by Gaplo917 on 8/7/2017.
 */


var Matter = __webpack_require__(294);












var MainGame = function (_BaseGame) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MainGame, _BaseGame);

  function MainGame() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MainGame);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MainGame.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MainGame)).call(this));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MainGame, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var app = this.app;
      app.stage.displayList = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["DisplayList"]();

      var engine = this.engine;
      var runner = this.runner;
      // The application will create a canvas element for you that you
      // can then insert into the DOM.
      document.body.appendChild(app.view);

      this.loadResource({
        onProgress: function onProgress(percentage) {
          __WEBPACK_IMPORTED_MODULE_10_jquery__('#progress').text("Loading " + parseInt(percentage) + "%");
        },
        onCompleted: function onCompleted(resources) {
          __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["b" /* LOAD_COMPLETE */]);

          var scene = new __WEBPACK_IMPORTED_MODULE_13__Scene1__["a" /* default */](resources);

          // for dev
          if (false) {}

          // scene = new Scene2(resources)
          // scene = new GameScenes.LevelScene1(resources, {passedLevel : 0})
          // scene = new GameScenes.LevelScene2(resources, {passedLevel : 0})
          // scene = new GameScenes.LevelScene3(resources, {passedLevel : 0})
          // scene = new GameScenes.EndGameScene(resources, {passedLevel : 0})
          // scene = new Scene2(resources)


          // Add the bunny to the scene we are building.
          app.stage.addChild(scene);

          // Listen for frame updates
          app.ticker.add(function (time) {
            try {
              __WEBPACK_IMPORTED_MODULE_9__tweenjs_tween_js___default.a.update();
            } catch (e) {
              console.warn("tween throw error, just ignore it", e);
            }
          });

          _this2.currentScene = scene;
          _this2.resources = resources;
        }
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */]).subscribe(function (event) {
        console.log("received next scene event...", event);
        app.stage.removeChild(_this2.currentScene);

        if (event.scene !== __WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].scenes.END_GAME) {
          __WEBPACK_IMPORTED_MODULE_6__SoundManager__["a" /* default */].instance.stopEffectSounds();
        }

        var scene = _this2.createSceneFromEvent(event);

        app.stage.addChild(scene);

        _this2.currentScene = scene;
      });
    }
  }, {
    key: "createSceneFromEvent",
    value: function createSceneFromEvent(event) {
      switch (event.scene) {
        case __WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].scenes.START:
          return new __WEBPACK_IMPORTED_MODULE_13__Scene1__["a" /* default */](this.resources);
        case __WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].scenes.SELECTION:
          return new __WEBPACK_IMPORTED_MODULE_14__Scene2__["a" /* default */](this.resources);
        case __WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].scenes.LEVEL_1:
          return new __WEBPACK_IMPORTED_MODULE_15__scenes_index__["a" /* LevelScene1 */](this.resources, event.data);
        case __WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].scenes.LEVEL_2:
          return new __WEBPACK_IMPORTED_MODULE_15__scenes_index__["b" /* LevelScene2 */](this.resources, event.data);
        case __WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].scenes.LEVEL_3:
          return new __WEBPACK_IMPORTED_MODULE_15__scenes_index__["c" /* LevelScene3 */](this.resources, event.data);
        case __WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].scenes.END_GAME:
          return new __WEBPACK_IMPORTED_MODULE_15__scenes_index__["d" /* EndGameScene */](this.resources, event.data);
        default:
          throw Error("unknown scene");
      }
    }
  }]);

  return MainGame;
}(__WEBPACK_IMPORTED_MODULE_7__BaseGame__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MainGame);

MainGame.instance = new MainGame();

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TreeStick; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var TreeStick = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TreeStick, _PIXI$Container);

  function TreeStick(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TreeStick);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TreeStick.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TreeStick)).call(this));

    _this.x = x;
    _this.y = y;

    var treeStick = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.small_wooden.name].texture);

    _this.treeStick = treeStick;

    _this.addChild(treeStick);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TreeStick, [{
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this2 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this2.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this2.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return TreeStick;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SoundUtils__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs__);


/**
 * Created by Gaplo917 on 16/8/2017.
 */



var SoundManager = function () {
  function SoundManager() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SoundManager);

    this.backgroundSound = null;
    this.effectSounds = {};
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SoundManager, [{
    key: 'playBackground',
    value: function playBackground(opt) {
      var sound = __WEBPACK_IMPORTED_MODULE_2__SoundUtils__["a" /* create */](opt);
      sound.play();

      this.backgroundSound = sound;
    }
  }, {
    key: 'playEffect',
    value: function playEffect(opt, onComplete) {
      var sound = __WEBPACK_IMPORTED_MODULE_2__SoundUtils__["a" /* create */](opt);

      sound.play(onComplete);

      // use the combined src as a ID
      var id = this.generateId(opt);

      // save it
      this.effectSounds[id] = sound;

      return sound;
    }
  }, {
    key: 'playEffectRx',
    value: function playEffectRx(opt) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].create(function (obs) {
        _this.playEffect(opt, function () {
          obs.next();
          obs.complete();
        });
      });
    }
  }, {
    key: 'stopEffect',
    value: function stopEffect(opt) {
      var id = this.generateId(opt);

      var sound = this.effectSounds[id];

      if (sound) {
        sound.stop();
      }
    }
  }, {
    key: 'generateId',
    value: function generateId(opt) {
      return Array.isArray(opt.src) ? opt.src[0] : opt.src;
    }
  }, {
    key: 'getSound',
    value: function getSound(opt) {
      return this.effectSounds[this.generateId(opt)] || this.backgroundSound;
    }
  }, {
    key: 'stopBackground',
    value: function stopBackground() {
      if (this.backgroundSound) {
        this.backgroundSound.stop();
      }
    }
  }, {
    key: 'stopEffectSounds',
    value: function stopEffectSounds() {
      for (var k in this.effectSounds) {
        this.effectSounds[k].stop();
      }
    }
  }, {
    key: 'stopAll',
    value: function stopAll() {
      this.stopBackground();
      this.stopEffectSounds();
    }
  }]);

  return SoundManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (SoundManager);


SoundManager.instance = new SoundManager();

/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Game__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Game__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Game___default.a
  }]
}));

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var Component = __webpack_require__(373)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(1071),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__game_MainGame__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__game_config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__game_Events__ = __webpack_require__(10);
//
//
//
//
//





// init the main game
__WEBPACK_IMPORTED_MODULE_0__game_MainGame__["a" /* default */].instance.init();

__WEBPACK_IMPORTED_MODULE_3__game_Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_3__game_Events__["b" /* LOAD_COMPLETE */]).take(1).subscribe(function () {
  __WEBPACK_IMPORTED_MODULE_2_jquery__('#pixel-loader').remove();
  __WEBPACK_IMPORTED_MODULE_2_jquery__('body').css({ 'background-color': '#000' });
});

// Auto resize the canvas
__WEBPACK_IMPORTED_MODULE_2_jquery__(window).resize(function () {
  resizeCanvas();
});

__WEBPACK_IMPORTED_MODULE_2_jquery__(function () {
  // initial call
  resizeCanvas();
});

function resizeCanvas() {
  var width = __WEBPACK_IMPORTED_MODULE_2_jquery__(window).width();
  var height = __WEBPACK_IMPORTED_MODULE_2_jquery__(window).height();
  console.log("window width=" + width + " height=" + height);

  if (height > width) {
    // portrait mode
    scratchWithFullHeight(width, height);
  } else {
    // landscape mode
    scratchWithFullWidth(width, height);
  }
}

function scratchWithFullWidth(width, height) {
  var targetRatio = height / width;

  var canvasSelector = __WEBPACK_IMPORTED_MODULE_2_jquery__('canvas');
  var loaderSelector = __WEBPACK_IMPORTED_MODULE_2_jquery__('#pixel-loader');
  var loaderSideLength = 30;

  canvasSelector.css('height', '100%');

  // the design is 4:3 (width:height)
  // calculate the origin width
  var oWidth = height / 3 * 4;
  var targetWidth = height / targetRatio;

  canvasSelector.css('width', oWidth + "px");

  if (targetWidth > oWidth) {
    // make padding
    console.log(targetWidth);
    var diff = Math.abs(targetWidth - oWidth);
    canvasSelector.css('top', '0');
    canvasSelector.css('left', diff / 2 + "px");
  } else {
    canvasSelector.css('top', '0');
    canvasSelector.css('left', '0');
  }

  loaderSelector.css('top', height / 2 - loaderSideLength + "px");
  loaderSelector.css('left', targetWidth / 2 + "px");
}

function scratchWithFullHeight(width, height) {
  var targetRatio = width / height;

  var canvasSelector = __WEBPACK_IMPORTED_MODULE_2_jquery__('canvas');
  var loaderSelector = __WEBPACK_IMPORTED_MODULE_2_jquery__('#pixel-loader');
  var loaderSideLength = 30;

  canvasSelector.css('width', '100%');

  // the design is 4:3 (width:height)
  // calculate the origin width
  var oHeight = width / 4 * 3;
  var targetHeight = width / targetRatio;

  canvasSelector.css('height', oHeight + "px");

  if (targetHeight > oHeight) {
    // make padding
    console.log(targetHeight);
    var diff = Math.abs(targetHeight - oHeight);
    canvasSelector.css('left', '0');
    canvasSelector.css('top', diff / 2 + "px");
  } else {
    canvasSelector.css('left', '0');
    canvasSelector.css('top', '0');
  }

  loaderSelector.css('top', targetHeight / 2 - loaderSideLength + "px");
  loaderSelector.css('left', width / 2 + "px");
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_display__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_display___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pixi_display__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pixi_spine__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pixi_spine___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pixi_spine__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GameUtils__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_fontSpy__ = __webpack_require__(410);





/**
 * Created by Gaplo917 on 8/7/2017.
 */





var Matter = __webpack_require__(294);





var WIDTH = __WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].dimen.width;
var HEIGHT = __WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].dimen.height;
/**
 * app: PIXI.Application
 * engine: Matter.Engine
 * runner: Matter.Runner
 */

var BaseGame = function () {
  function BaseGame() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, BaseGame);

    var isAntiAlias = (__WEBPACK_IMPORTED_MODULE_8__GameUtils__["a" /* getQueryVariable */]('aa') || "").startsWith("1");
    var quality = Math.min(parseInt(__WEBPACK_IMPORTED_MODULE_8__GameUtils__["a" /* getQueryVariable */]('q') || 5), 10);
    var isGPU = (__WEBPACK_IMPORTED_MODULE_8__GameUtils__["a" /* getQueryVariable */]('gpu') || "1").startsWith("1");
    console.log("using antialias = " + isAntiAlias + " and quality = " + quality);
    // Rendering Part
    var app = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["Application"]({
      width: WIDTH,
      height: HEIGHT,
      transparent: true,
      antialias: isAntiAlias,
      sharedTicker: true,
      resolution: quality / 20 + 0.5 /* 0.5 is base quality (1024 * 768)*/
      , forceFXAA: quality === 1 ? false : isAntiAlias,
      forceCanvas: !isGPU,
      legacy: true,
      backgroundColor: 0x000001
    });
    app.view.id = "game-canvas";
    app.ticker.minFPS = 60;
    if (!(app.renderer instanceof __WEBPACK_IMPORTED_MODULE_5_pixi_js__["WebGLRenderer"]) && isGPU) {
      alert("瀏灠器過舊並不支援 WebGL，有可能出現相容性問題！\n此遊戲只支援:\nIE 11\nEdge 14+\nFirefox 24+\nChrome 33+\nSafari 8+\nOpera 47\niOS 8.0+\nAndroid 5.0+(內核更新至 Chromium 56+)\nChrome for Android 61+");
    }
    // show events log when in dev mode
    if (false) {
      var _loop = function _loop(event) {
        var eventName = Events[event];
        console.log("dev add event logging", eventName);
        Events.hub.getEventStream(eventName).subscribe(function (e) {
          console.log(eventName, e);
        });
      };

      for (var event in Events) {
        _loop(event);
      }
    }

    // assign to properties
    this.app = app;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(BaseGame, [{
    key: "enableMatterPhysicEngine",
    value: function enableMatterPhysicEngine() {
      // Physics Engine Part
      var runner = Matter.Runner.create();
      var engine = Matter.Engine.create();

      var render = Matter.Render.create({
        element: document.body,
        engine: engine,
        options: {
          width: WIDTH,
          height: HEIGHT
        }

      });

      // only render physic engine in dev mode
      if (false) {
        //Matter.Render.run(render)
        //app.stage.alpha = 0.5
      }

      this.engine = engine;
      this.runner = runner;
    }
  }, {
    key: "isMatterEngineEnabled",
    value: function isMatterEngineEnabled() {
      return this.runner && this.engine;
    }
  }, {
    key: "loadResource",
    value: function loadResource(_ref) {
      var _this = this;

      var onProgress = _ref.onProgress,
          onCompleted = _ref.onCompleted;

      return this.loadQuestionJson().then(function (questions) {
        // dynamic inject to R.question
        __WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].question = questions;

        var fontsP = _this.loadFonts();
        var imagesP = _this.loadImages();
        var vos = __WEBPACK_IMPORTED_MODULE_9_lodash__["flatMapDeep"](__WEBPACK_IMPORTED_MODULE_9_lodash__["values"](questions).map(function (level) {
          return level.map(function (lv) {
            return lv.vo;
          });
        }));

        var soundsP = _this.loadSounds(vos);

        var totalResCount = __WEBPACK_IMPORTED_MODULE_8__GameUtils__["b" /* isIE11 */]() ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].sounds).length + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].images).length : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].sounds).length + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].images).length + vos.length;

        var count = 0;
        __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["d" /* LOADED_FILE */]).subscribe(function (loaded) {
          count += parseInt(loaded);
          var percent = count / totalResCount * 100;
          onProgress(percent >= 100 ? 100 : percent);
        });

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([fontsP, soundsP, imagesP]).then(function (values) {
          console.log("finish all loading");

          var _values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(values, 3),
              a = _values[0],
              b = _values[1],
              resources = _values[2];

          onCompleted(resources);
        });
      });
    }
  }, {
    key: "loadQuestionJson",
    value: function loadQuestionJson() {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var queue = new createjs.LoadQueue();
        queue.on("fileload", function (event) {
          resolve(event.result);
        });
        queue.loadFile({ id: "question.json", src: 'static/config/question.json' });
        queue.load();
      });
    }
  }, {
    key: "loadFonts",
    value: function loadFonts() {
      var p1 = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__plugins_fontSpy__["a" /* fontSpy */])(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].textStyles.chinese(0).fontFamily, {
          glyphs: '你',
          success: function success() {
            console.log(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].textStyles.chinese(0).fontFamily + "  loaded successfully");
            resolve();
          },
          failure: function failure() {
            console.warn(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].textStyles.chinese(0).fontFamily + "\u5B57\u9AD4\u52A0\u8F09\u5931\u6557");
            resolve();
          }
        });
      });

      var p2 = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__plugins_fontSpy__["a" /* fontSpy */])(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].textStyles.pinyin(0).fontFamily, {
          glyphs: '^',
          success: function success() {
            console.log(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].textStyles.pinyin(0).fontFamily + "  loaded successfully");
            resolve();
          },
          failure: function failure() {
            console.warn(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].textStyles.pinyin(0).fontFamily + "\u5B57\u9AD4\u52A0\u8F09\u5931\u6557");
            resolve();
          }
        });
      });

      var p3 = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__plugins_fontSpy__["a" /* fontSpy */])(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].textStyles.timer(0).fontFamily, {
          glyphs: '123',
          success: function success() {
            console.log(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].textStyles.timer(0).fontFamily + "  loaded successfully");
            resolve();
          },
          failure: function failure() {
            console.warn(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].textStyles.timer(0).fontFamily + " \u5B57\u9AD4\u52A0\u8F09\u5931\u6557");
            resolve();
          }
        });
      });

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([p1, p2, p3]);
    }
  }, {
    key: "loadSounds",
    value: function loadSounds(vos) {
      var queue = new createjs.LoadQueue();
      queue.installPlugin(createjs.Sound);
      queue.setMaxConnections(40);
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].sounds).map(function (k) {
        return __WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].sounds[k];
      }).map(function (_ref2) {
        var src = _ref2.src,
            volume = _ref2.volume;

        queue.loadFile({ id: src, src: Array.isArray(src) ? src[0] : src }, { loadNow: false });
      });

      vos.filter(function (vo) {
        return vo === "undefined";
      }).map(function (vo) {
        return { id: vo, src: "static/vo/" + vo + ".mp3" };
      }).map(function (_ref3) {
        var id = _ref3.id,
            src = _ref3.src;

        var volume = 1;
        // dynamic inject
        __WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].vos[id] = {
          src: [src],
          volume: volume
        };

        if (!__WEBPACK_IMPORTED_MODULE_8__GameUtils__["b" /* isIE11 */]()) {
          // IE 11 can't load many file
          queue.loadFile({ id: src, src: Array.isArray(src) ? src[0] : src }, { loadNow: false });
        }
      });

      queue.on("fileload", function () {
        __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["d" /* LOADED_FILE */], 1);
      });

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        queue.on("complete", function () {
          resolve();
        });

        queue.load();
      });
    }
  }, {
    key: "loadImages",
    value: function loadImages() {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var loader = __WEBPACK_IMPORTED_MODULE_5_pixi_js__["loader"];
        loader.reset();

        for (var key in __WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].images) {
          if (__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].images.hasOwnProperty(key)) {
            var res = __WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].images[key];
            if (Array.isArray(res)) {
              res.forEach(function (_) {
                loader.add(_.name, _.src);
              });
            } else {
              loader.add(res.name, res.src);
            }
          }
        }

        for (var _key in __WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].spriteSheets) {
          if (__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].spriteSheets.hasOwnProperty(_key)) {
            (function () {
              var res = __WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].spriteSheets[_key];
              if (Array.isArray(res.json)) {
                res.json.forEach(function (src, i) {
                  loader.add(res.id + "-" + i, src);
                });
              } else {
                loader.add(res.id, res.json);
              }
            })();
          }
        }

        for (var _key2 in __WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].spines) {
          if (__WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].spines.hasOwnProperty(_key2)) {
            (function () {
              var res = __WEBPACK_IMPORTED_MODULE_10__config_R__["a" /* default */].spines[_key2];
              if (Array.isArray(res.json)) {
                res.json.forEach(function (src, i) {
                  loader.add(res.id + "-" + i, src);
                });
              } else {
                loader.add(res.id, res.json);
              }
            })();
          }
        }

        loader.onProgress.add(function (a, b) {
          __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["d" /* LOADED_FILE */], 1);
        });

        loader.load(function (loader, resources) {
          resolve(resources);
        });
      });
    }
  }]);

  return BaseGame;
}();

/* harmony default export */ __webpack_exports__["a"] = (BaseGame);

/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_Scene__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_Button__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_FullScreenBg__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SoundUtils__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SoundManager__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AnimationUtils__ = __webpack_require__(22);





/**
 * Created by Gaplo917 on 10/7/2017.
 */










var Scene1 = function (_Scene) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Scene1, _Scene);

  function Scene1(resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Scene1);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Scene1.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Scene1)).call(this));

    var initBg = new __WEBPACK_IMPORTED_MODULE_8__objects_FullScreenBg__["a" /* default */](resources[__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].images.initBg.name].texture);

    var startBtn = new __WEBPACK_IMPORTED_MODULE_7__objects_Button__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].dimen.width / 2, 1200, resources[__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].images.startBtn.name].texture, false);

    startBtn.addOnClickListener(function () {
      startBtn.removeOnClickListener();
      startBtn.touchEffect(true);
      _this.nextScene();
    });

    _this.addChild(initBg);
    _this.addChild(startBtn);

    _this.startBtn = startBtn;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Scene1, [{
    key: "nextScene",
    value: function nextScene() {
      console.log("go to next scene 2");
      __WEBPACK_IMPORTED_MODULE_12__AnimationUtils__["a" /* AnimationUtils */].fadeOut(this.startBtn);

      __WEBPACK_IMPORTED_MODULE_11__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].sounds.pth_6bs2_p52_ga_01, function () {
        __WEBPACK_IMPORTED_MODULE_9__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_9__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].scenes.SELECTION });
      });
    }
  }]);

  return Scene1;
}(__WEBPACK_IMPORTED_MODULE_5__objects_Scene__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Scene1);

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__objects_Scene__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_Button__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_FullScreenBg__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SoundManager__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MainGame__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__characters_common_BannerText__ = __webpack_require__(121);





/**
 * Created by Gaplo917 on 10/7/2017.
 */










var Scene2 = function (_Scene) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Scene2, _Scene);

  function Scene2(resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Scene2);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Scene2.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Scene2)).call(this));

    __WEBPACK_IMPORTED_MODULE_10__SoundManager__["a" /* default */].instance.stopBackground();

    var bg1 = new __WEBPACK_IMPORTED_MODULE_8__objects_FullScreenBg__["a" /* default */](resources[__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].images.selectStageBg.name].texture);
    var playBtn = new __WEBPACK_IMPORTED_MODULE_7__objects_Button__["a" /* default */](1800, 1340, resources[__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].images.selectionBtnPlay.name].texture);
    var hearBtn = new __WEBPACK_IMPORTED_MODULE_7__objects_Button__["a" /* default */](1620, 1340, resources[__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].images.selectionBtnRE.name].texture);

    // Add the bunny to the scene we are building.
    _this.addChild(bg1);
    _this.addChild(playBtn);
    _this.addChild(hearBtn);

    _this.schedulePlayVO = setTimeout(function () {
      playBtn.addOnClickListener(function () {
        __WEBPACK_IMPORTED_MODULE_10__SoundManager__["a" /* default */].instance.stopEffect(__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].sounds.pth_6bs2_p52_ga_02);
        _this.nextScene(__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].scenes.LEVEL_3, { passedLevel: 0 });
      });

      hearBtn.addOnClickListener(function () {
        __WEBPACK_IMPORTED_MODULE_10__SoundManager__["a" /* default */].instance.stopEffect(__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].sounds.pth_6bs2_p52_ga_02);
        __WEBPACK_IMPORTED_MODULE_10__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].sounds.pth_6bs2_p52_ga_02);
      });
      __WEBPACK_IMPORTED_MODULE_10__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_6__config_R__["a" /* default */].sounds.pth_6bs2_p52_ga_02);
    }, 0);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Scene2, [{
    key: "destroy",
    value: function destroy() {
      clearTimeout(this.schedulePlayVO);
    }
  }, {
    key: "nextScene",
    value: function nextScene(sceneId, data) {
      console.log("go to next scene 3 with data:", data);
      this.destroy();
      __WEBPACK_IMPORTED_MODULE_9__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_9__Events__["c" /* NEXT_SCENE */], { scene: sceneId, data: data });
    }
  }]);

  return Scene2;
}(__WEBPACK_IMPORTED_MODULE_5__objects_Scene__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Scene2);

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Camel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var Camel = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Camel, _PIXI$Container);

  function Camel(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Camel);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Camel.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Camel)).call(this));

    _this.x = x;
    _this.y = y;

    var camel = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.camel);
    // const camelWalking = new CustomAnimatedSprite(0,0, resources, R.spriteSheets.camelWalking)
    // const camelFrighten = new CustomAnimatedSprite(0,0, resources, R.spriteSheets.camelFrighten)
    // const camelProtagonist = new CustomAnimatedSprite(0,0, resources, R.spriteSheets.camelProtagonist)
    // const camelCarryWalk = new CustomAnimatedSprite(0,0, resources, R.spriteSheets.camelCarryWalk)
    // const camelCarryWink = new CustomAnimatedSprite(0,0, resources, R.spriteSheets.camelCarryWink)

    _this.camel = camel;
    // this.camelWalking = camelWalking
    // this.camelFrighten = camelFrighten
    // this.camelProtagonist = camelProtagonist
    // this.camelCarryWalk = camelCarryWalk
    // this.camelCarryWink = camelCarryWink

    _this.addChildAt(camel, 0);
    _this.normal();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Camel, [{
    key: 'removeAllChild',
    value: function removeAllChild() {
      __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.remove(this.winkingTween);
    }
  }, {
    key: 'carryWalking',
    value: function carryWalking(distance) {
      var _this2 = this;

      this.camel.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.camel.animations.walking, true);
      var duration = distance * 3;

      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ x: this.x + distance }, duration).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {
        __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level1_donkey);

        _this2.camel.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.camel.animations.frighten, false, function () {
          _this2.camel.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.camel.animations.protagonist, false, function () {
            __WEBPACK_IMPORTED_MODULE_10__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_10__Events__["j" /* ENABLE_QUESTION_BOX */], {});
          });
        });
      }).start();
    }
  }, {
    key: 'camelWithManWalking',
    value: function camelWithManWalking(man, distance, onComplete) {
      var _this3 = this;

      this.camel.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.camel.animations.carryWalk, true);
      var duration = distance * 2;

      var currentX = this.x;
      this._manTween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(man).to({ x: '+' + distance }, duration).start();

      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ x: '+' + distance }, duration).onComplete(function () {
        onComplete();
        _this3.normal();
      }).start();
    }
  }, {
    key: 'normal',
    value: function normal() {
      this.camel.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.camel.animations.winking, true);
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this4 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this4.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this4.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Camel;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Eagle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var Eagle = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Eagle, _PIXI$Container);

  function Eagle(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Eagle);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Eagle.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Eagle)).call(this));

    _this.x = x;
    _this.y = y;

    var eagle = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.eagle);

    _this.eagle = eagle;
    _this.addChild(eagle);
    _this.keepFlying();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Eagle, [{
    key: 'flyToMan',
    value: function flyToMan() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ x: _this2.x - 1080 }, 2000).start();

        _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ y: _this2.y - 100 }, 750).repeat(2).yoyo(true).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Sinusoidal.InOut).onComplete(function () {
          _this2.eagle.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.eagle.animations.flyingWithoutKey, true);
          obs.next();
          obs.complete();
        }).start();
      });
    }
  }, {
    key: 'normal',
    value: function normal() {
      this.eagle.stopAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.eagle.animations.flyingWithKey);
    }
  }, {
    key: 'keepFlying',
    value: function keepFlying() {
      this.eagle.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.eagle.animations.flyingWithKey, true);
    }
  }]);

  return Eagle;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FireBalls; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var FireBalls = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FireBalls, _PIXI$Container);

  function FireBalls(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FireBalls);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FireBalls.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(FireBalls)).call(this));

    _this.x = x;
    _this.y = y;

    var fireBall1 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.fireball.name].texture);
    var fireBall2 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](200, 500, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.fireball.name].texture);
    var fireBall3 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](600, 300, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.fireball.name].texture);
    var fireBall4 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](1000, 450, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.fireball.name].texture);
    var fireBall5 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](800, 650, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.fireball.name].texture);

    _this.fireBall1 = fireBall1;
    _this.fireBall2 = fireBall2;
    _this.fireBall3 = fireBall3;
    _this.fireBall4 = fireBall4;
    _this.fireBall5 = fireBall5;

    var fireBalls = [fireBall1, fireBall2, fireBall3, fireBall4, fireBall5];
    fireBalls.forEach(function (fb) {
      fb.scale.x = 0.4;
      fb.scale.y = 0.4;
    });

    _this.addChild(fireBall1);
    _this.addChild(fireBall2);
    _this.addChild(fireBall3);
    _this.addChild(fireBall4);
    _this.addChild(fireBall5);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FireBalls, [{
    key: 'dropping',
    value: function dropping(lifeBar) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.wrong_ans_eff_1);

      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ x: -500 }, 2500).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.InOut).onComplete(function () {}).start();

      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ y: 1400 }, 2500).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Sinusoidal.InOut).onComplete(function () {
        _this2.reset();
      }).start();
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.x = 2500;
      this.y = -1000;
    }
  }]);

  return FireBalls;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Flute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var Flute = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Flute, _PIXI$Container);

  function Flute(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Flute);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Flute.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Flute)).call(this));

    _this.x = x;
    _this.y = y;
    var flute = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.flute);

    _this.addChild(flute);

    _this.flute = flute;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Flute, [{
    key: 'jumpIn',
    value: function jumpIn() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ x: 950, y: 950 }, 1500).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.InOut).onComplete(function () {
          obs.next();
          obs.complete();
        }).start();
      });
    }
  }, {
    key: 'playMusic',
    value: function playMusic() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level1_flute);

        _this3.flute.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.flute.animations.animation, false, function () {
          _this3.removeChild(_this3.flute);

          obs.next();
          obs.complete();
        });
      });
    }
  }]);

  return Flute;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hole; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var Hole = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Hole, _PIXI$Container);

  function Hole(x, y) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Hole);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Hole.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Hole)).call(this));

    _this.x = x;
    _this.y = y;

    var rect = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["Graphics"]();
    rect.beginFill(0, 0.1);
    rect.drawRect(0, 0, 450, 200);
    rect.endFill();
    rect.visible = false;

    var sRect = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["Sprite"](rect.generateCanvasTexture());
    sRect.anchor.x = 0.5;
    sRect.anchor.y = 0.5;

    _this.addChild(sRect);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Hole, [{
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this2 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this2.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this2.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Hole;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Key; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var Key = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Key, _PIXI$Container);

  function Key(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Key);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Key.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Key)).call(this));

    _this.x = x;
    _this.y = y;

    var keyNormal = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.key.name].texture);

    _this.keyNormal = keyNormal;
    _this.displayGroup = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["DisplayGroup"](3, true);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Key, [{
    key: 'openDoor',
    value: function openDoor() {
      this.x = 650;
      this.y = 850;
      this.rotation = -2.5;
      this.addChild(this.keyNormal);

      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ x: 1950 }, 2000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onComplete(function () {}).start();

      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ y: 1020 }, 2000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onComplete(function () {}).start();
    }
  }, {
    key: 'dropToMan',
    value: function dropToMan() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this2.x = 600;
        _this2.y = 420;
        _this2.addChild(_this2.keyNormal);

        _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ y: 760 }, 1000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quartic.In).onComplete(function () {
          obs.next();
          obs.complete();
        }).start();
      });
    }
  }, {
    key: 'normal',
    value: function normal() {
      this.removeChildren();
      this.addChild(this.keyNormal);
    }
  }]);

  return Key;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Snake; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var Snake = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Snake, _PIXI$Container);

  function Snake(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Snake);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Snake.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Snake)).call(this));

    _this.x = x;
    _this.y = y;

    var snakeLooking = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.snake);

    _this.snakeLooking = snakeLooking;

    _this.addChild(snakeLooking);
    _this.snakeLooking.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.snake.animations.stop, false);
    _this.keepMoving();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Snake, [{
    key: 'looking',
    value: function looking() {
      var _this2 = this;

      this.removeChildren();
      this.addChildAt(this.snakeLooking, 0);

      this.snakeLooking.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.snake.animations.looking, true);

      var ty = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).delay(800).to({ y: this.y - 300 }, 3000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.InOut);

      var tx = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ x: this.x + 1000 }, 3000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.InOut).onStart(function () {
        _this2.scale.x = -1;
      }).onComplete(function () {
        _this2.normal();
        __WEBPACK_IMPORTED_MODULE_10__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_10__Events__["j" /* ENABLE_QUESTION_BOX */], {});
      });

      this._tween = ty.chain(tx).start();
    }
  }, {
    key: 'normal',
    value: function normal() {
      this.scale.x = 1;
      this.snakeLooking.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.snake.animations.stop, false);
    }
  }, {
    key: 'keepMoving',
    value: function keepMoving() {
      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ rotation: -0.2 }, 1500).repeat(Infinity).yoyo(true).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Sinusoidal.InOut).onComplete(function () {}).start();
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this3 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this3.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this3.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Snake;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Statue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var Statue = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Statue, _PIXI$Container);

  function Statue(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Statue);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Statue.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Statue)).call(this));

    _this.x = x;
    _this.y = y;

    var status = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.statue);

    _this.status = status;

    _this.addChild(status);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Statue, [{
    key: 'nodding',
    value: function nodding() {
      __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level1_nod);
      this.status.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.statue.animations.nodding, false, function () {
        __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.stopEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level1_nod);
      });
    }
  }, {
    key: 'normal',
    value: function normal() {}
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this2 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this2.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this2.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Statue;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Stone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var Stone = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Stone, _PIXI$Container);

  function Stone(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Stone);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Stone.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Stone)).call(this));

    _this.x = x;
    _this.y = y;

    var stone = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.stone.name].texture);

    _this.stone = stone;
    _this.addChild(_this.stone);

    _this.scale.set(0.5);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Stone, [{
    key: 'dropping',
    value: function dropping() {
      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this.scale).to({ x: 1, y: 1 }, 1300).onComplete(function () {
        __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level1_dropstone);
        __WEBPACK_IMPORTED_MODULE_10__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_10__Events__["j" /* ENABLE_QUESTION_BOX */], {});
      }).start();
      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ y: 1300 }, 1300).onComplete(function () {
        __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level1_dropstone);
        __WEBPACK_IMPORTED_MODULE_10__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_10__Events__["j" /* ENABLE_QUESTION_BOX */], {});
      }).start();
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this2 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this2.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this2.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Stone;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Arrows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var Arrows = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Arrows, _PIXI$Container);

  function Arrows(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Arrows);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Arrows.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Arrows)).call(this));

    _this.x = x;
    _this.y = y;

    var arrow1 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.arrow.name].texture);
    var arrow2 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](200, 500, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.arrow.name].texture);
    var arrow3 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](600, 300, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.arrow.name].texture);
    var arrow4 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](1000, 450, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.arrow.name].texture);
    var arrow5 = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](800, 650, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.arrow.name].texture);

    _this.arrow1 = arrow1;
    _this.arrow2 = arrow2;
    _this.arrow3 = arrow3;
    _this.arrow4 = arrow4;
    _this.arrow5 = arrow5;

    var arrows = [arrow1, arrow2, arrow3, arrow4, arrow5];
    arrows.forEach(function (a) {
      a.rotation = -0.6;
    });

    _this.addChild(arrow1);
    _this.addChild(arrow2);
    _this.addChild(arrow3);
    _this.addChild(arrow4);
    _this.addChild(arrow5);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Arrows, [{
    key: 'shooting',
    value: function shooting(lifeBar) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.wrong_ans_eff_2);

      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ x: -500 }, 2500).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.InOut).onComplete(function () {}).start();

      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ y: 1400 }, 2500).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Sinusoidal.InOut).onComplete(function () {
        _this2.reset();
      }).start();
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.x = 2500;
      this.y = -1000;
    }
  }]);

  return Arrows;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Beacon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var Beacon = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Beacon, _PIXI$Container);

  function Beacon(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Beacon);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Beacon.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Beacon)).call(this));

    _this.x = x;
    _this.y = y;

    var beaconBack = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](30, 5, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.beaconBack.name].texture);
    var beaconFront = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](30, 5, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.beaconFront.name].texture);
    var fire = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](5, -190, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.fire);

    _this.addChild(beaconBack);
    _this.addChild(beaconFront);
    _this.fire = fire;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Beacon, [{
    key: 'firing',
    value: function firing() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this2.addChildAt(_this2.fire, 1);
        _this2.fire.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.fire.animations.fire, true);
        obs.next();
        obs.complete();
      });
    }
  }]);

  return Beacon;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BirdTower; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var BirdTower = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BirdTower, _PIXI$Container);

  function BirdTower(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BirdTower);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BirdTower.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(BirdTower)).call(this));

    _this.x = x;
    _this.y = y;

    var tower = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.birdTower);

    _this.addChild(tower);

    _this.tower = tower;
    _this.tower.spine.skeleton.setToSetupPose();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(BirdTower, [{
    key: 'rebuild',
    value: function rebuild() {
      var _this2 = this;

      // build tower1
      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (observer) {
        __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level2_movestone);

        _this2.tower.playAnimation('animation', false, function () {
          observer.next();
          observer.complete();
        });
      });
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this3 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this3.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this3.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return BirdTower;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Grass; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SoundManager__ = __webpack_require__(26);




/**
 * Created by Gaplo917 on 6/9/2017.
 */











var Grass = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Grass, _PIXI$Container);

  function Grass(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Grass);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Grass.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Grass)).call(this));

    _this.x = x;
    _this.y = y;

    // const grass = new CustomAnimatedSprite(0,0, resources, R.spines.grass)

    // grass.playAnimation(R.spines.grass.animations.animation, true)
    // this.addChild(grass)
    return _this;
  }

  return Grass;
}(__WEBPACK_IMPORTED_MODULE_4_pixi_js__["Container"]);

/***/ }),

/***/ 396:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Indian; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var Indian = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Indian, _PIXI$Container);

  function Indian(x, y, resources) {
    var withKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Indian);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Indian.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Indian)).call(this));

    _this.x = x;
    _this.y = y;

    // create for ref
    _this.indianWithKey = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.indianWithKey);
    _this.indianWihoutKey = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.indian);

    _this.indian = withKey ? _this.indianWithKey : new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.indian);

    _this.addChild(_this.indian);

    _this.normal();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Indian, [{
    key: 'normal',
    value: function normal() {
      this.indian.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.indian.animations.animation, true);
    }
  }, {
    key: 'happy',
    value: function happy() {
      this.removeChild(this.indian);
      this.addChild(this.indianWihoutKey);

      this.indianWihoutKey.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.indian.animations.happy, true);
    }
  }, {
    key: 'randomIntFromInterval',
    value: function randomIntFromInterval(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    }
  }]);

  return Indian;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 397:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Key; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var Key = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Key, _PIXI$Container);

  function Key(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Key);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Key.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Key)).call(this));

    _this.x = x;
    _this.y = y;

    var key = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.key.name].texture);

    _this.key = key;
    _this.displayGroup = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["DisplayGroup"](3, true);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Key, [{
    key: 'openDoor',
    value: function openDoor() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this2.addChild(_this2.key);
        _this2.rotation = -2.5;

        _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ x: 1950 }, 2000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.InOut).onComplete(function () {}).start();

        _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ y: 1020 }, 2000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.InOut).onComplete(function () {
          obs.next();
          obs.complete();
        }).start();
      });
    }
  }, {
    key: 'normal',
    value: function normal() {}
  }]);

  return Key;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pecker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var Pecker = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pecker, _PIXI$Container);

  function Pecker(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Pecker);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Pecker.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Pecker)).call(this));

    _this.x = x;
    _this.y = y;

    var pecker = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.pecker);
    _this.pecker = pecker;

    _this.addChild(pecker);

    _this.normal();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Pecker, [{
    key: 'removeAllChild',
    value: function removeAllChild() {
      this.removeChildren();
    }
  }, {
    key: 'normal',
    value: function normal() {
      this.pecker.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.pecker.animations.idle, true);
    }
  }, {
    key: 'pecking',
    value: function pecking() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (observer) {
        __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level2_woodpecker);

        _this2.pecker.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.pecker.animations.peck, true);
        observer.next();
        observer.complete();
      }).delay(2000).do(function () {
        __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.stopEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level2_woodpecker);
        _this2.normal();
      });
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this3 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this3.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this3.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Pecker;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wood; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var Wood = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Wood, _PIXI$Container);

  function Wood(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Wood);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Wood.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Wood)).call(this));

    _this.x = x;
    _this.y = y;

    //const wood = new Image(300,0, resources[R.images.wood.name].texture)
    var woodCutting = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](1175, -820, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.axeWood);
    var preFire = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](-140, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.preFire);
    var fire = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](-65, -70, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.fire);

    _this.preFire = preFire;
    _this.fire = fire;

    _this.woodCutting = woodCutting;
    _this.woodCutting.alpha = 0;
    _this.woodCutting.scale.set(0, 0);

    woodCutting.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.axeWood.animations.beforeAxe, false);
    _this.addChild(woodCutting);

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Wood, [{
    key: 'appear',
    value: function appear() {
      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (observer) {

        observer.next();
        observer.complete();
      });
    }
  }, {
    key: 'peckingByPecker',
    value: function peckingByPecker() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (observer) {
        _this2.woodCutting.alpha = 1;
        new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2.woodCutting.scale).to({ x: 1, y: 1 }, 500).start();

        new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2.woodCutting).to({ x: 235, y: -150 }, 2000).onComplete(function () {
          observer.next();
          observer.complete();
        }).start();
      });
    }
  }, {
    key: 'cutting',
    value: function cutting() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {

        setTimeout(function () {
          _this3.addChildAt(_this3.preFire, 0);
          __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level2_movewood);

          _this3.preFire.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.preFire.animations.settingWood, false, function () {
            _this3.preFire.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.preFire.animations.idleWood, false);
            obs.next();
            obs.complete();
          });
        }, 2000);

        _this3.woodCutting.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.axeWood.animations.axe, false, function () {
          _this3.removeChild(_this3.woodCutting);
        });
      });
    }
  }, {
    key: 'onFire',
    value: function onFire() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this4.addChild(_this4.fire);
        __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level2_fire);

        _this4.fire.scale.set(2, 3);
        _this4.fire.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.fire.animations.fire, true);

        obs.next();
        obs.complete();
      });
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this5 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this5.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this5.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Wood;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BigStone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */











var BigStone = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BigStone, _PIXI$Container);

  function BigStone(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BigStone);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BigStone.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(BigStone)).call(this));

    _this.x = x;
    _this.y = y;

    var bigStone = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.big_stone.name].texture);

    _this.bigStone = bigStone;

    _this.addChild(bigStone);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(BigStone, [{
    key: 'rolling',
    value: function rolling() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ rotation: -2 }, 3000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {}).start();

        _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ x: _this2.x - 330 }, 3000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {

          _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ x: _this2.x - 400 }, 1200).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {}).start();
          _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ y: _this2.y + 1000 }, 1200).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.In).onComplete(function () {
            __WEBPACK_IMPORTED_MODULE_14__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level3_splash);

            obs.next();
            obs.complete();
          }).start();
        }).start();
      });
    }
  }, {
    key: 'sinking',
    value: function sinking() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        obs.next();
        obs.complete();
        _this3._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this3).to({ y: _this3.y + 1000 }, 3000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.In).onComplete(function () {}).start();
      });
    }
  }]);

  return BigStone;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Crocodile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var Crocodile = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Crocodile, _PIXI$Container);

  function Crocodile(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Crocodile);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Crocodile.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Crocodile)).call(this));

    _this.x = x;
    _this.y = y;

    var crocodile = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.crocodile);

    _this.crocodile = crocodile;

    _this.addChild(crocodile);
    _this.normal();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Crocodile, [{
    key: 'removeAllChild',
    value: function removeAllChild() {
      this.removeChildren();
    }
  }, {
    key: 'normal',
    value: function normal() {
      this.crocodile.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.crocodile.animations.idle, true);
    }
  }, {
    key: 'stunning',
    value: function stunning() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this2.crocodile.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.crocodile.animations.dead, false, function () {
          obs.next();
          obs.complete();
        });
      });
    }
  }, {
    key: 'sinking',
    value: function sinking() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this3._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this3).to({ y: _this3.y + 1000 }, 4000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.In).onComplete(function () {
          obs.next();
          obs.complete();
        }).start();
      });
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this4 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this4.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this4.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Crocodile;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Owl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TreeStick__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */












var Owl = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Owl, _PIXI$Container);

  function Owl(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Owl);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Owl.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Owl)).call(this));

    _this.x = x;
    _this.y = y;

    _this.originalPos = { x: x, y: y };

    var owl = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.owl);

    _this.owl = owl;

    _this.addChild(owl);
    _this.sleeping();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Owl, [{
    key: 'removeAllChild',
    value: function removeAllChild() {
      this.removeChildren();
      __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.remove(this.winkingTween);
    }
  }, {
    key: 'wakeUp',
    value: function wakeUp() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        __WEBPACK_IMPORTED_MODULE_15__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level3_dropapple);

        _this2.owl.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.owl.animations.hitByApple, false, function () {
          _this2.normal();
          obs.next();
          obs.complete();
        });
      });
    }
  }, {
    key: 'sleeping',
    value: function sleeping() {
      this.owl.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.owl.animations.idleSleeping, true);
    }
  }, {
    key: 'flyWithStick',
    value: function flyWithStick(oldTreeStick) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        __WEBPACK_IMPORTED_MODULE_15__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level3_flapwings);

        _this3.owl.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.owl.animations.flyingWithStick, true);

        _this3._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this3).to({ x: _this3.originalPos.x + 100 /* due to the flip*/, y: _this3.originalPos.y }, 4000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {
          _this3.x = _this3.originalPos.x;
          _this3.owl.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.owl.animations.idleWaked, true);
          obs.next();
          obs.complete();

          oldTreeStick.x = 50;
          oldTreeStick.y = 80;
          oldTreeStick.rotation = 1.35;
          _this3.addChild(oldTreeStick);
        }).start();
      });
    }
  }, {
    key: 'flyingToWoodStick',
    value: function flyingToWoodStick() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this4.normal();

        __WEBPACK_IMPORTED_MODULE_15__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level3_flapwings);
        _this4.owl.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.owl.animations.flying, true);

        _this4._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this4).to({ x: _this4.x + 1250 }, 4000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {
          obs.next();
          obs.complete();
        }).start();
      });
    }
  }, {
    key: 'normal',
    value: function normal() {
      this.owl.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.owl.animations.idleWaked, true);
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this5 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this5.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this5.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Owl;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Rock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var Rock = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Rock, _PIXI$Container);

  function Rock(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Rock);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Rock.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Rock)).call(this));

    _this.x = x;
    _this.y = y;
    _this.ox = x;
    _this.oy = y;

    var rock = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.big_stone.name].texture);
    _this.rock = rock;
    _this.addChild(rock);

    _this.scale.x = 0.5;
    _this.scale.y = 0.5;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Rock, [{
    key: 'dropping',
    value: function dropping() {
      var _this2 = this;

      this._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(this).to({ x: -400 }, 1800).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onUpdate(function () {
        _this2.rotation -= 0.2;
      }).onComplete(function () {
        _this2.reset();
      }).start();
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.x = this.ox;
      this.y = this.oy;
    }
  }]);

  return Rock;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var Spider = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Spider, _PIXI$Container);

  function Spider(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Spider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Spider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Spider)).call(this));

    _this.x = x;
    _this.y = y;

    var spider = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 240, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.spider);
    var key = new __WEBPACK_IMPORTED_MODULE_8__objects_Image__["a" /* default */](0, 0, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.key.name].texture);

    var refBone = spider.spine.skeleton.findBone("bone");

    _this.resources = resources;
    _this.spider = spider;
    _this.key = key;

    _this.key.displayGroup = new __WEBPACK_IMPORTED_MODULE_5_pixi_js__["DisplayGroup"](3, true);

    _this.addChild(key);
    _this.addChild(_this.spider);
    _this.normal();

    __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].interval(1000 / 60).observeOn(__WEBPACK_IMPORTED_MODULE_6_rxjs__["Scheduler"].animationFrame).takeUntil(__WEBPACK_IMPORTED_MODULE_10__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_10__Events__["c" /* NEXT_SCENE */])).takeWhile(function () {
      return !_this.hasNet;
    }).subscribe(function () {
      key.x = refBone.worldX + 20;
      key.y = refBone.worldY + 500;
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Spider, [{
    key: 'openDoor',
    value: function openDoor() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this2.key.rotation = -2.5;
        _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2.key).to({ x: 1830 }, 2000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.InOut).onComplete(function () {}).start();

        _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2.key).to({ y: 450 }, 2000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Quadratic.InOut).onComplete(function () {
          obs.next();
          obs.complete();
        }).start();
      });
    }
  }, {
    key: 'putTheKeyInNet',
    value: function putTheKeyInNet(key) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {

        _this3.spider.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.spider.animations.animation, false, function () {
          _this3.hasNet = true;

          _this3.setChildIndex(_this3.spider, 0);
          new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this3.key).to({ x: 1760, y: 450 }, 1000).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Exponential.In).onComplete(function () {
            obs.next();
            obs.complete();
          }).start();
        });
      });
    }
  }, {
    key: 'removeAllChild',
    value: function removeAllChild() {
      __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.remove(this.winkingTween);
      //this.addChild(this.cobweb)
    }
  }, {
    key: 'normal',
    value: function normal() {
      this.spider.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.spider.animations.idle, true);
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this4 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this4.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this4.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Spider;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tortoise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__GameUtils__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__objects_CustomAnimatedSprite__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SoundManager__ = __webpack_require__(26);





/**
 * Created by Gaplo917 on 6/9/2017.
 */













var Tortoise = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tortoise, _PIXI$Container);

  function Tortoise(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Tortoise);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tortoise.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Tortoise)).call(this));

    _this.x = x;
    _this.y = y;

    var tortoise = new __WEBPACK_IMPORTED_MODULE_14__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.tortoise);

    _this.tortoise = tortoise;

    _this.addChild(tortoise);
    _this.normal();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Tortoise, [{
    key: 'removeAllChild',
    value: function removeAllChild() {
      this.removeChildren();
    }
  }, {
    key: 'retracting',
    value: function retracting() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this2.tortoise.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.tortoise.animations.retracting, false, function () {
          obs.next();
          obs.complete();
          _this2._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this2).to({ y: _this2.y - 10 }, 1000).repeat(Infinity).yoyo(true).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {}).start();
        });
      });
    }
  }, {
    key: 'walking',
    value: function walking(duration, offset) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this3.tortoise.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.tortoise.animations.walking, true);

        _this3._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this3).to({ x: _this3.x - 1600 + offset }, duration).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {
          obs.next();
          obs.complete();
        }).start();

        _this3._tween = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween(_this3).to({ y: 1450 }, duration).easing(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Easing.Linear.None).onComplete(function () {}).start();
      });
    }
  }, {
    key: 'normal',
    value: function normal() {
      this.tortoise.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.tortoise.animations.idle, true);
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this4 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this4.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this4.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Tortoise;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WoodBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AnimationUtils__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__ = __webpack_require__(23);





/**
 * Created by Gaplo917 on 6/9/2017.
 */










var WoodBox = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WoodBox, _PIXI$Container);

  function WoodBox(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WoodBox);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WoodBox.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WoodBox)).call(this));

    _this.x = x;
    _this.y = y;

    var woodBox = new __WEBPACK_IMPORTED_MODULE_13__objects_CustomAnimatedSprite__["a" /* default */](0, 0, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.woodBox);

    _this.woodBox = woodBox;
    _this.scale.set(2.05);

    _this.addChild(woodBox);

    _this.woodBox.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.woodBox.animations.idle, false);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WoodBox, [{
    key: 'open',
    value: function open() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_rxjs__["Observable"].create(function (obs) {
        _this2.woodBox.playAnimation(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].spines.woodBox.animations.open, false, function () {
          obs.next();
          obs.complete();
        });
      });
    }
  }, {
    key: 'addOnClickListener',
    value: function addOnClickListener(fn) {
      var _this3 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {}).on('touchstart', function () {}).on('mouseout', function () {}).on('mouseover', function () {}).on('mouseup', function (e) {
        fn(e);
        _this3.removeOnClickListener();
      }).on('touchend', function (e) {
        fn(e);
        _this3.removeOnClickListener();
      });
    }
  }, {
    key: 'removeOnClickListener',
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return WoodBox;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Container"]);

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CustomMultiStyleText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pixi_js__);










/**
 * Added a new Style `lineSpace (number)`
 * Added default <u></u> tag, for underline the text
 */
var CustomMultiStyleText = function (_MultiStyleText) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(CustomMultiStyleText, _MultiStyleText);

  function CustomMultiStyleText(text, styles) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CustomMultiStyleText);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CustomMultiStyleText.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CustomMultiStyleText)).call(this, text, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      "u": {} }, styles)));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(CustomMultiStyleText, [{
    key: "updateText",
    value: function updateText() {
      /**************** COPIED AND MODIFIED FROM pixi-multistyle-text.js ****************************/
      var _this = this;
      if (!this.dirty) {
        return;
      }
      this.texture.baseTexture.resolution = this.resolution;
      var textStyles = this.textStyles;
      var outputText = this.text;
      if (this._style.wordWrap) {
        outputText = this.wordWrap(this.text);
      }
      var lines = outputText.split(/(?:\r\n|\r|\n)/);
      var outputTextData = this._getTextDataPerLine(lines);
      var lineWidths = [];
      var lineYMins = [];
      var lineYMaxs = [];
      var baselines = [];
      var maxLineWidth = 0;
      for (var i = 0; i < lines.length; i++) {
        var lineWidth = 0;
        var lineYMin = 0;
        var lineYMax = 0;
        var baseline = 0;
        for (var j = 0; j < outputTextData[i].length; j++) {
          var sty = outputTextData[i][j].style;
          this.context.font = this.getFontString(sty);
          outputTextData[i][j].width = this.context.measureText(outputTextData[i][j].text).width;
          if (outputTextData[i][j].text.length === 0) {
            outputTextData[i][j].width += (outputTextData[i][j].text.length - 1) * sty.letterSpacing;
            if (j > 0) {
              lineWidth += sty.letterSpacing / 2;
            }
            if (j < outputTextData[i].length - 1) {
              lineWidth += sty.letterSpacing / 2;
            }
          }
          lineWidth += outputTextData[i][j].width;
          outputTextData[i][j].fontProperties = __WEBPACK_IMPORTED_MODULE_8_pixi_js__["TextMetrics"].measureFont(this.context.font);
          outputTextData[i][j].height = outputTextData[i][j].fontProperties.fontSize + outputTextData[i][j].style.strokeThickness;
          if (typeof sty.valign === "number") {
            lineYMin = Math.min(lineYMin, sty.valign - outputTextData[i][j].fontProperties.descent);
            lineYMax = Math.max(lineYMax, sty.valign + outputTextData[i][j].fontProperties.ascent);
          } else {
            lineYMin = Math.min(lineYMin, -outputTextData[i][j].fontProperties.descent);
            lineYMax = Math.max(lineYMax, outputTextData[i][j].fontProperties.ascent);
          }
        }
        lineWidths[i] = lineWidth;
        lineYMins[i] = lineYMin;
        lineYMaxs[i] = lineYMax;
        maxLineWidth = Math.max(maxLineWidth, lineWidth);
      }
      var stylesArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(textStyles).map(function (key) {
        return textStyles[key];
      });
      var maxStrokeThickness = stylesArray.reduce(function (prev, cur) {
        return Math.max(prev, cur.strokeThickness || 0);
      }, 0);
      var maxLineSpace = stylesArray.reduce(function (prev, cur) {
        return Math.max(prev, cur.lineSpace || 1);
      }, 1);

      var dropShadowPadding = this.getDropShadowPadding();
      var totalHeight = lineYMaxs.reduce(function (prev, cur) {
        return prev + cur;
      }, 0) - lineYMins.reduce(function (prev, cur) {
        return prev + cur;
      }, 0);
      var width = maxLineWidth + maxStrokeThickness + 2 * dropShadowPadding;
      var height = (totalHeight + 2 * dropShadowPadding) * maxLineSpace;
      this.canvas.width = (width + this.context.lineWidth) * this.resolution;
      this.canvas.height = height * this.resolution;
      this.context.scale(this.resolution, this.resolution);
      this.context.textBaseline = "alphabetic";
      this.context.lineJoin = "round";
      var basePositionY = dropShadowPadding;
      var drawingData = [];
      for (var i = 0; i < outputTextData.length; i++) {
        var line = outputTextData[i];
        var linePositionX = void 0;
        switch (this._style.align) {
          case "left":
            linePositionX = dropShadowPadding;
            break;
          case "center":
            linePositionX = dropShadowPadding + (maxLineWidth - lineWidths[i]) / 2;
            break;
          case "right":
            linePositionX = dropShadowPadding + maxLineWidth - lineWidths[i];
            break;
        }
        for (var j = 0; j < line.length; j++) {
          var _a = line[j],
              style = _a.style,
              text = _a.text,
              fontProperties = _a.fontProperties,
              width_1 = _a.width,
              height_1 = _a.height,
              tagName = _a.tagName;
          linePositionX += maxStrokeThickness / 2;
          var linePositionY = maxStrokeThickness / 2 + basePositionY + fontProperties.ascent;
          switch (style.valign) {
            case "top":
              break;
            case "baseline":
              linePositionY += lineYMaxs[i] - fontProperties.ascent;
              break;
            case "middle":
              linePositionY += (lineYMaxs[i] - lineYMins[i] - fontProperties.ascent - fontProperties.descent) / 2;
              break;
            case "bottom":
              linePositionY += lineYMaxs[i] - lineYMins[i] - fontProperties.ascent - fontProperties.descent;
              break;
            default:
              linePositionY += lineYMaxs[i] - fontProperties.ascent - style.valign;
              break;
          }
          if (style.letterSpacing === 0) {
            drawingData.push({
              text: text,
              style: style,
              x: linePositionX,
              y: linePositionY * maxLineSpace,
              width: width_1,
              ascent: fontProperties.ascent,
              descent: fontProperties.descent,
              tagName: tagName
            });
            linePositionX += line[j].width;
          } else {
            this.context.font = this.getFontString(line[j].style);
            for (var k = 0; k < text.length; k++) {
              if (k > 0 || j > 0) {
                linePositionX += style.letterSpacing / 2;
              }
              drawingData.push({
                text: text.charAt(k),
                style: style,
                x: linePositionX,
                y: linePositionY * maxLineSpace,
                width: width_1,
                ascent: fontProperties.ascent,
                descent: fontProperties.descent,
                tagName: tagName
              });
              linePositionX += this.context.measureText(text.charAt(k)).width;
              if (k < text.length - 1 || j < line.length - 1) {
                linePositionX += style.letterSpacing / 2;
              }
            }
          }
          linePositionX -= maxStrokeThickness / 2;
        }
        basePositionY += lineYMaxs[i] - lineYMins[i];
      }
      this.context.save();
      drawingData.forEach(function (_a) {
        var style = _a.style,
            text = _a.text,
            x = _a.x,
            y = _a.y;
        if (!style.dropShadow) {
          return;
        }
        _this.context.font = _this.getFontString(style);
        var dropFillStyle = style.dropShadowColor;
        if (typeof dropFillStyle === "number") {
          dropFillStyle = __WEBPACK_IMPORTED_MODULE_8_pixi_js__["utils"].hex2string(dropFillStyle);
        }
        _this.context.shadowColor = dropFillStyle;
        _this.context.shadowBlur = style.dropShadowBlur;
        _this.context.shadowOffsetX = Math.cos(style.dropShadowAngle) * style.dropShadowDistance * _this.resolution;
        _this.context.shadowOffsetY = Math.sin(style.dropShadowAngle) * style.dropShadowDistance * _this.resolution;
        _this.context.fillText(text, x, y);
      });
      this.context.restore();
      drawingData.forEach(function (_a) {
        var style = _a.style,
            text = _a.text,
            x = _a.x,
            y = _a.y,
            width = _a.width,
            ascent = _a.ascent,
            descent = _a.descent,
            tagName = _a.tagName;
        _this.context.font = _this.getFontString(style);
        var strokeStyle = style.stroke;
        if (typeof strokeStyle === "number") {
          strokeStyle = __WEBPACK_IMPORTED_MODULE_8_pixi_js__["utils"].hex2string(strokeStyle);
        }
        _this.context.strokeStyle = strokeStyle;
        _this.context.lineWidth = style.strokeThickness;

        var fillStyle = style.fill;
        if (typeof fillStyle === "number") {
          fillStyle = __WEBPACK_IMPORTED_MODULE_8_pixi_js__["utils"].hex2string(fillStyle);
        } else if (Array.isArray(fillStyle)) {
          for (var i = 0; i < fillStyle.length; i++) {
            var fill = fillStyle[i];
            if (typeof fill === "number") {
              fillStyle[i] = __WEBPACK_IMPORTED_MODULE_8_pixi_js__["utils"].hex2string(fill);
            }
          }
        }
        _this.context.fillStyle = _this._generateFillStyle(new __WEBPACK_IMPORTED_MODULE_8_pixi_js__["TextStyle"](style), [text]);
        if (style.stroke && style.strokeThickness) {
          _this.context.strokeText(text, x, y);
        }
        if (style.fill) {
          _this.context.fillText(text, x, y);
        }
        var debugSpan = style.debug === undefined ? __WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.spans.enabled : style.debug;
        if (debugSpan) {
          _this.context.lineWidth = 1;
          if (__WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.spans.bounding) {
            _this.context.fillStyle = __WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.spans.bounding;
            _this.context.strokeStyle = __WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.spans.bounding;
            _this.context.beginPath();
            _this.context.rect(x, y - ascent, width, ascent + descent);
            _this.context.fill();
            _this.context.stroke();
            _this.context.stroke();
          }
          if (__WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.spans.baseline) {
            _this.context.strokeStyle = __WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.spans.baseline;
            _this.context.beginPath();
            _this.context.moveTo(x, y);
            _this.context.lineTo(x + width, y);
            _this.context.closePath();
            _this.context.stroke();
          }
          if (__WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.spans.top) {
            _this.context.strokeStyle = __WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.spans.top;
            _this.context.beginPath();
            _this.context.moveTo(x, y - ascent);
            _this.context.lineTo(x + width, y - ascent);
            _this.context.closePath();
            _this.context.stroke();
          }
          if (__WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.spans.bottom) {
            _this.context.strokeStyle = __WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.spans.bottom;
            _this.context.beginPath();
            _this.context.moveTo(x, y + descent);
            _this.context.lineTo(x + width, y + descent);
            _this.context.closePath();
            _this.context.stroke();
          }
          if (__WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.spans.text) {
            _this.context.fillStyle = "#ffffff";
            _this.context.strokeStyle = "#000000";
            _this.context.lineWidth = 2;
            _this.context.font = "8px monospace";
            _this.context.strokeText(tagName, x, y - ascent + 8);
            _this.context.fillText(tagName, x, y - ascent + 8);
            _this.context.strokeText(width.toFixed(2) + "x" + (ascent + descent).toFixed(2), x, y - ascent + 16);
            _this.context.fillText(width.toFixed(2) + "x" + (ascent + descent).toFixed(2), x, y - ascent + 16);
          }
        }
      });
      if (__WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.objects.enabled) {
        if (__WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.objects.bounding) {
          this.context.fillStyle = __WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.objects.bounding;
          this.context.beginPath();
          this.context.rect(0, 0, width, height);
          this.context.fill();
        }
        if (__WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a.debugOptions.objects.text) {
          this.context.fillStyle = "#ffffff";
          this.context.strokeStyle = "#000000";
          this.context.lineWidth = 2;
          this.context.font = "8px monospace";
          this.context.strokeText(width.toFixed(2) + "x" + height.toFixed(2), 0, 8, width);
          this.context.fillText(width.toFixed(2) + "x" + height.toFixed(2), 0, 8, width);
        }
      }

      // Custom logic
      // handle underline <u></u>
      drawingData.forEach(function (_a) {
        var style = _a.style,
            text = _a.text,
            x = _a.x,
            y = _a.y,
            width = _a.width,
            ascent = _a.ascent,
            descent = _a.descent,
            tagName = _a.tagName;
        _this.context.font = _this.getFontString(style);
        var strokeStyle = style.stroke;
        if (typeof strokeStyle === "number") {
          strokeStyle = __WEBPACK_IMPORTED_MODULE_8_pixi_js__["utils"].hex2string(strokeStyle);
        }
        _this.context.strokeStyle = strokeStyle;
        _this.context.lineWidth = style.strokeThickness;
        var fillStyle = style.fill;
        if (typeof fillStyle === "number") {
          fillStyle = __WEBPACK_IMPORTED_MODULE_8_pixi_js__["utils"].hex2string(fillStyle);
        } else if (Array.isArray(fillStyle)) {
          for (var i = 0; i < fillStyle.length; i++) {
            var fill = fillStyle[i];
            if (typeof fill === "number") {
              fillStyle[i] = __WEBPACK_IMPORTED_MODULE_8_pixi_js__["utils"].hex2string(fill);
            }
          }
        }
        _this.context.fillStyle = _this._generateFillStyle(new __WEBPACK_IMPORTED_MODULE_8_pixi_js__["TextStyle"](style), [text]);
        if (style.stroke && style.strokeThickness) {
          _this.context.strokeText(text, x, y);
        }
        if (style.fill) {
          _this.context.fillText(text, x, y);
        }

        if (tagName === "u") {
          _this.context.strokeStyle = style.stroke;
          _this.context.fillStyle = style.fill;
          _this.context.lineWidth = style.fontSize / 10;
          _this.context.rect(x, y + descent, width, style.fontSize / 4);
          _this.context.fill();
          _this.context.stroke();
        }
      });

      // COPIED FROM SOURCE
      this.updateTexture();
    }
  }]);

  return CustomMultiStyleText;
}(__WEBPACK_IMPORTED_MODULE_7_pixi_multistyle_text_dist_pixi_multistyle_text___default.a);

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js__);




/**
 * Created by Gaplo917 on 23/8/2017.
 */




var FullScreenOverlay = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(FullScreenOverlay, _PIXI$Container);

  function FullScreenOverlay() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0x000000;
    var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FullScreenOverlay);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FullScreenOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(FullScreenOverlay)).call(this));

    var bgColor = new __WEBPACK_IMPORTED_MODULE_4_pixi_js__["Graphics"]();
    bgColor.beginFill(color);
    bgColor.drawRect(0, 0, __WEBPACK_IMPORTED_MODULE_5__config_R__["a" /* default */].dimen.width, __WEBPACK_IMPORTED_MODULE_5__config_R__["a" /* default */].dimen.height);

    _this.addChild(bgColor);

    _this.alpha = alpha;
    return _this;
  }

  return FullScreenOverlay;
}(__WEBPACK_IMPORTED_MODULE_4_pixi_js__["Container"]);

/* harmony default export */ __webpack_exports__["a"] = (FullScreenOverlay);

/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__tweenjs_tween_js__);






/**
 * Created by Gaplo917 on 6/9/2017.
 */






var MAX_LENGTH = 778;

var TimeBar = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TimeBar, _PIXI$Container);

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TimeBar, null, [{
    key: "COUNT_DOWN_END",
    get: function get() {
      return "TIMEBAR_COUNT_DOWN_END";
    }
  }]);

  function TimeBar(x, y, resources) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TimeBar);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TimeBar.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TimeBar)).call(this));

    _this.x = x;
    _this.y = y;

    var clock = new __WEBPACK_IMPORTED_MODULE_7__Image__["a" /* default */](-7, 20, resources[__WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].images.clock.name].texture);
    var timebarBg = new __WEBPACK_IMPORTED_MODULE_7__Image__["a" /* default */](228, 26, resources[__WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].images.timeBar.name].texture);
    clock.scale.x = 0.5;
    clock.scale.y = 0.5;

    timebarBg.scale.x = 0.5;
    timebarBg.scale.y = 0.5;

    var runningBar = new __WEBPACK_IMPORTED_MODULE_6_pixi_js__["Container"]();
    runningBar.x = 35;
    runningBar.y = 9;

    var mask = new __WEBPACK_IMPORTED_MODULE_6_pixi_js__["Graphics"]();
    mask.beginFill(0xFFFF00);
    mask.drawRoundedRect(135, 64, MAX_LENGTH / 2, 71 / 2, 35.5 / 2);
    runningBar.mask = mask;

    _this.addChild(timebarBg);
    _this.addChild(runningBar);
    _this.addChild(clock);

    _this.runningBar = runningBar;

    _this.setBar(1);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TimeBar, [{
    key: "setBar",
    value: function setBar(ratio) {
      var runningBar = this.runningBar;

      if (this.currentBar) {
        runningBar.removeChild(this.currentBar);
      }

      var graphics = new __WEBPACK_IMPORTED_MODULE_6_pixi_js__["Graphics"]();
      graphics.beginFill(0xff675b, 1);
      graphics.drawRect(0, 0, MAX_LENGTH * ratio / 2, 71 / 2);
      graphics.endFill();

      runningBar.addChild(graphics);
      this.currentBar = graphics;
    }

    // auto end when the count down finish

  }, {
    key: "start",
    value: function start(ticker, seconds) {
      var _this2 = this;

      this._frame = 0;
      var fps = ticker.FPS;

      var update = function update() {
        if (_this2._frame >= fps * seconds) {
          _this2.setBar(0);
          _this2._timeLeft = 0;
          ticker.remove(update);
          __WEBPACK_IMPORTED_MODULE_9__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_9__Events__["h" /* TIMES_UP */]);
        } else {
          var timeElapsed = _this2._frame / fps;
          var timeLeft = seconds - timeElapsed;
          _this2.setBar(timeLeft / seconds);

          _this2._timeLeft = timeLeft;
        }

        _this2._frame += 1;
      };

      ticker.add(update);

      this.update = update;
      this.ticker = ticker;
      this.seconds = seconds;
    }
  }, {
    key: "deductTime",
    value: function deductTime(second) {
      var _this3 = this;

      this._frame += second * this.ticker.FPS;

      var textStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, new __WEBPACK_IMPORTED_MODULE_6_pixi_js__["TextStyle"](__WEBPACK_IMPORTED_MODULE_8__config_R__["a" /* default */].textStyles.timer(60)), {
        fill: '#FFFFFF'
      });

      var deduceText = new __WEBPACK_IMPORTED_MODULE_6_pixi_js__["Text"]("-10", textStyle);

      deduceText.x = 450 * (this._timeLeft / this.seconds);
      deduceText.y = 0;
      this.addChild(deduceText);

      new __WEBPACK_IMPORTED_MODULE_10__tweenjs_tween_js___default.a.Tween(deduceText).to({ y: -300, alpha: 0 }, 5000).easing(__WEBPACK_IMPORTED_MODULE_10__tweenjs_tween_js___default.a.Easing.Quadratic.Out).onComplete(function () {
        _this3.removeChild(deduceText);
      }).start();
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.ticker && this.update) {
        this.ticker.remove(this.update);
      }
    }
  }, {
    key: "restart",
    value: function restart() {
      if (!this.ticker || !this.seconds) {
        throw Error("you should run CircleTimer.start(ticker, seconds) first");
      }
      this.start(this.ticker, this.seconds);
    }
  }, {
    key: "value",
    get: function get() {
      return this._timeLeft;
    }
  }]);

  return TimeBar;
}(__WEBPACK_IMPORTED_MODULE_6_pixi_js__["Container"]);

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fontSpy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* jQuery-FontSpy.js v3.0.0
 * https://github.com/patrickmarabeas/jQuery-FontSpy.js
 *
 * Copyright 2013, Patrick Marabeas http://pulse-dev.com
 * Released under the MIT license
 * http://opensource.org/licenses/mit-license.php
 *
 * Date: 02/11/2015
 */


var fontSpy = function fontSpy(fontName, conf) {
  var $html = __WEBPACK_IMPORTED_MODULE_0_jquery__('html'),
      $body = __WEBPACK_IMPORTED_MODULE_0_jquery__('body'),
      fontFamilyName = fontName;

  // Throw error if fontName is not a string or not is left as an empty string
  if (typeof fontFamilyName !== 'string' || fontFamilyName === '') {
    throw 'A valid fontName is required. fontName must be a string and must not be an empty string.';
  }

  var defaults = {
    font: fontFamilyName,
    fontClass: fontFamilyName.toLowerCase().replace(/\s/g, ''),
    success: function success() {},
    failure: function failure() {},
    testFont: 'Courier New',
    testString: 'QW@HhsXJ',
    glyphs: '',
    delay: 50,
    timeOut: 1000,
    callback: __WEBPACK_IMPORTED_MODULE_0_jquery__["noop"]
  };

  var config = __WEBPACK_IMPORTED_MODULE_0_jquery__["extend"](defaults, conf);

  var $tester = __WEBPACK_IMPORTED_MODULE_0_jquery__('<span>' + config.testString + config.glyphs + '</span>').css('position', 'absolute').css('top', '-9999px').css('left', '-9999px').css('visibility', 'hidden').css('fontFamily', config.testFont).css('fontSize', '250px');

  $body.append($tester);

  var fallbackFontWidth = $tester.outerWidth();

  $tester.css('fontFamily', config.font + ',' + config.testFont);

  var failure = function failure() {
    $html.addClass("no-" + config.fontClass);
    if (config && config.failure) {
      config.failure();
    }
    config.callback(new Error('FontSpy timeout'));
    $tester.remove();
  };

  var success = function success() {
    config.callback();
    $html.addClass(config.fontClass);
    if (config && config.success) {
      config.success();
    }
    $tester.remove();
  };

  var retry = function retry() {
    setTimeout(checkFont, config.delay);
    config.timeOut = config.timeOut - config.delay;
  };

  var checkFont = function checkFont() {
    var loadedFontWidth = $tester.outerWidth();

    if (fallbackFontWidth !== loadedFontWidth) {
      success();
    } else if (config.timeOut < 0) {
      failure();
    } else {
      retry();
    }
  };

  checkFont();
};

/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EndGameScene; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Scene__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__objects_FullScreenBg__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__characters_common_Man__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__InfoScene__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__objects_Button__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SoundManager__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__tweenjs_tween_js__);






/**
 * Created by Gaplo917 on 9/7/2017.
 */













var EndGameScene = function (_Scene) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(EndGameScene, _Scene);

  function EndGameScene(resources, settings) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, EndGameScene);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EndGameScene.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(EndGameScene)).call(this));

    _this.resources = resources;
    _this.settings = settings;

    var bg = new __WEBPACK_IMPORTED_MODULE_9__objects_FullScreenBg__["a" /* default */](resources[__WEBPACK_IMPORTED_MODULE_7__config_R__["a" /* default */].images.end_game_bg.name].texture);
    var restartBtn = function () {
      var btn = new __WEBPACK_IMPORTED_MODULE_14__objects_Button__["a" /* default */](1940, 1450, resources[__WEBPACK_IMPORTED_MODULE_7__config_R__["a" /* default */].images.returnBtn.name].texture);
      btn.displayGroup = new __WEBPACK_IMPORTED_MODULE_6_pixi_js__["DisplayGroup"](11, true);
      return btn;
    }();
    var map = new __WEBPACK_IMPORTED_MODULE_15__objects_Image__["a" /* default */](1198, 1385, resources[__WEBPACK_IMPORTED_MODULE_7__config_R__["a" /* default */].images.map.name].texture);

    var man = new __WEBPACK_IMPORTED_MODULE_10__characters_common_Man__["a" /* Man */](-200, 1200, resources);

    map.scale.set(0.50);

    _this.addChild(bg);
    _this.addChild(man);
    _this.addChild(map);
    _this.addChild(restartBtn);

    restartBtn.addOnClickListener(function () {
      _this.backToSelection();
    });

    var r0 = man.endGameWalking();
    var r1 = man.pickingUp(_this, map);

    requestAnimationFrame(function () {
      r0.do(function () {
        return r1.subscribe();
      }).delay(2700).do(function () {
        _this.popUpInfoScene(resources[__WEBPACK_IMPORTED_MODULE_7__config_R__["a" /* default */].images.success_03.name].texture);
        man.endGameStop();
        __WEBPACK_IMPORTED_MODULE_16__SoundManager__["a" /* default */].instance.stopEffect(__WEBPACK_IMPORTED_MODULE_7__config_R__["a" /* default */].sounds.sfx_clap);
      }).flatMap(function () {
        __WEBPACK_IMPORTED_MODULE_16__SoundManager__["a" /* default */].instance.stopAll();
        return __WEBPACK_IMPORTED_MODULE_16__SoundManager__["a" /* default */].instance.playEffectRx(__WEBPACK_IMPORTED_MODULE_7__config_R__["a" /* default */].sounds.game_feedback_good);
      }).subscribe();
    });

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(EndGameScene, [{
    key: "popUpInfoScene",
    value: function popUpInfoScene(texture) {
      this.infoScene = new __WEBPACK_IMPORTED_MODULE_13__InfoScene__["a" /* default */](this.resources, texture);
      this.addChild(this.infoScene);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      __WEBPACK_IMPORTED_MODULE_17__tweenjs_tween_js___default.a.removeAll();
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(EndGameScene.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(EndGameScene.prototype), "destroy", this).call(this, { children: true });
    }
  }, {
    key: "backToSelection",
    value: function backToSelection() {
      this.destroy();
      __WEBPACK_IMPORTED_MODULE_12__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_12__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_7__config_R__["a" /* default */].scenes.SELECTION });
    }
  }]);

  return EndGameScene;
}(__WEBPACK_IMPORTED_MODULE_8__objects_Scene__["a" /* default */]);

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LevelScene1; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Scene__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_FullScreenBg__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SoundManager__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__objects_Button__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__characters_common_BannerText__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__characters_common_Timer__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__controllers_QuestionController__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__characters_common_QuestionBox__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__controllers_LifeBarController__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__characters_common_Heart__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__characters_level1_Eagle__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__characters_level1_Statue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__characters_common_Man__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__characters_level1_Snake__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__characters_level1_Camel__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__characters_level1_Key__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__characters_level1_Stone__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__characters_level1_FireBalls__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__characters_common_SpeechBubble__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__characters_common_CheckPointArrow__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__characters_level1_Hole__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__InfoScene__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__characters_common_Door__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__characters_level1_Flute__ = __webpack_require__(386);






/**
 * Created by Gaplo917 on 3/9/2017.
 */
































var GameState = {
  ANSWER_CORRECT: "ANSWER_1_CORRECT",
  ANSWER_WRONG: "ANSWER_1_WRONG",
  PASS_GAME: "PASS_GAME",
  LOSE_GAME: "LOSE_GAME",
  CHECKPOINT_1: 1,
  CHECKPOINT_2: 2,
  CHECKPOINT_3: 3,
  CHECKPOINT_4: 4
};

var END_GAME = 3;

var LevelScene1 = function (_Scene) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(LevelScene1, _Scene);

  function LevelScene1(resources, settings) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LevelScene1);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LevelScene1.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LevelScene1)).call(this));

    __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.stopBackground();

    _this.resources = resources;
    _this.settings = settings;
    _this.passedLevel = settings.passedLevel + 1;

    var questionController = new __WEBPACK_IMPORTED_MODULE_17__controllers_QuestionController__["a" /* default */](__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].settings.level1Settings);
    questionController.prepareQuestions();

    var hearts = [0, 1, 2].map(function (i) {
      return new __WEBPACK_IMPORTED_MODULE_20__characters_common_Heart__["a" /* default */](i * 120 + 1330, 100, resources);
    });

    var bg1 = new __WEBPACK_IMPORTED_MODULE_10__objects_FullScreenBg__["a" /* default */](resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.level1Bg1.name].texture);
    var bg2 = new __WEBPACK_IMPORTED_MODULE_10__objects_FullScreenBg__["a" /* default */](resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.level1Bg2.name].texture);
    var bannerText = new __WEBPACK_IMPORTED_MODULE_15__characters_common_BannerText__["a" /* BannerText */](100, 55, "請判斷哪個是普通話詞語？", resources);
    var restartBtn = new __WEBPACK_IMPORTED_MODULE_14__objects_Button__["a" /* default */](1940, 1450, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.returnBtn.name].texture);
    var timer = new __WEBPACK_IMPORTED_MODULE_16__characters_common_Timer__["a" /* Timer */](1790, 100, resources);
    var questionBox = new __WEBPACK_IMPORTED_MODULE_18__characters_common_QuestionBox__["a" /* default */](600, 200, questionController.questions, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].settings.level1Settings.level);
    var lifeBarController = new __WEBPACK_IMPORTED_MODULE_19__controllers_LifeBarController__["a" /* default */](hearts, 3);
    var heartBox = new __WEBPACK_IMPORTED_MODULE_21__objects_Image__["a" /* default */](1450, 100, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.heartBox.name].texture);
    var lizard = new __WEBPACK_IMPORTED_MODULE_21__objects_Image__["a" /* default */](1830, 1350, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.lizard.name].texture);
    var door = new __WEBPACK_IMPORTED_MODULE_35__characters_common_Door__["a" /* Door */](2150, 920, resources);

    //const startptArrow = new CheckPointArrow(600, 500, -0.5, resources[R.images.checkPointArrow.name].texture)
    var chkptArrow1 = new __WEBPACK_IMPORTED_MODULE_32__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](520, 450, -0.8, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);
    var chkptArrow2 = new __WEBPACK_IMPORTED_MODULE_32__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](800, 1450, -4, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);
    var chkptArrow3 = new __WEBPACK_IMPORTED_MODULE_32__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](1175, 750, -1.6, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);
    var chkptArrow4 = new __WEBPACK_IMPORTED_MODULE_32__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](1350, 400, -2.5, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);

    //animation
    var hole = new __WEBPACK_IMPORTED_MODULE_33__characters_level1_Hole__["a" /* Hole */](1150, 1250);
    var bubble = new __WEBPACK_IMPORTED_MODULE_31__characters_common_SpeechBubble__["a" /* SpeechBubble */](600, 800, resources);
    var eagle = new __WEBPACK_IMPORTED_MODULE_22__characters_level1_Eagle__["a" /* Eagle */](1620, 330, resources);
    var statue = new __WEBPACK_IMPORTED_MODULE_23__characters_level1_Statue__["a" /* Statue */](1080, 830, resources);
    var snake = new __WEBPACK_IMPORTED_MODULE_25__characters_level1_Snake__["a" /* Snake */](1100, 1300, resources);
    var camel = new __WEBPACK_IMPORTED_MODULE_26__characters_level1_Camel__["a" /* Camel */](-100, 880, resources);
    var man = new __WEBPACK_IMPORTED_MODULE_24__characters_common_Man__["a" /* Man */](280, 1100, resources);
    var flute = new __WEBPACK_IMPORTED_MODULE_36__characters_level1_Flute__["a" /* Flute */](-100, 950, resources);
    var key = new __WEBPACK_IMPORTED_MODULE_27__characters_level1_Key__["a" /* Key */](1730, 430, resources);
    var stone = new __WEBPACK_IMPORTED_MODULE_29__characters_level1_Stone__["a" /* Stone */](1100, 1100, resources);
    var fireBalls = new __WEBPACK_IMPORTED_MODULE_30__characters_level1_FireBalls__["a" /* FireBalls */](2000, -1000, resources);

    _this.addChild(bg1);
    _this.addChild(stone);
    _this.addChild(snake);
    _this.addChild(bg2);
    _this.addChild(statue);
    _this.addChild(eagle);
    _this.addChild(lizard);
    _this.addChild(camel);
    _this.addChild(man);
    _this.addChild(flute);
    _this.addChild(bubble);
    _this.addChild(bannerText);
    _this.addChild(timer);
    _this.addChild(questionBox);
    _this.addChild(heartBox);
    _this.addChild(door);
    _this.addChild(restartBtn);
    _this.addChild(key);
    _this.addChild(fireBalls);
    //this.addChild(startptArrow)
    _this.addChild(chkptArrow1);
    _this.addChild(chkptArrow2);
    _this.addChild(chkptArrow3);
    _this.addChild(chkptArrow4);
    _this.addChild(hole);
    hearts.forEach(function (_) {
      return _this.addChild(_);
    });

    _this.currentCheckPoint = 0;
    _this.questionBox = questionBox;
    _this.questionController = questionController;
    _this.timer = timer;
    _this.lifeBarController = lifeBarController;
    _this.eagle = eagle;
    _this.statue = statue;
    _this.man = man;
    _this.snake = snake;
    _this.camel = camel;
    _this.stone = stone;
    _this.key = key;
    _this.fireBalls = fireBalls;
    //this.startptArrow = startptArrow
    _this.chkptArrow1 = chkptArrow1;
    _this.chkptArrow2 = chkptArrow2;
    _this.chkptArrow3 = chkptArrow3;
    _this.chkptArrow4 = chkptArrow4;
    _this.hole = hole;
    _this.door = door;
    _this.flute = flute;

    _this.schedulePlayStartGameVO = setTimeout(function () {
      _this.playStartGameVO(function () {

        __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playBackground(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.bg_6bg1_bg1);

        var t1 = bubble.appear();
        var t2 = bubble.disappear();
        var t3 = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween().onComplete(function () {
          timer.start();
          _this.questionBox.enableQuestionBox();
          // startptArrow.flashing()
          // camel.addOnClickListener(() => {
          //   startptArrow.remove()
          // })
        });
        t1.chain(t2);
        t2.chain(t3);
        t1.start();
      });
    }, 1500);

    restartBtn.displayGroup = new __WEBPACK_IMPORTED_MODULE_6_pixi_js__["DisplayGroup"](9, true);
    restartBtn.addOnClickListener(function () {
      _this.backToSelection();
    });

    _this.setUpEventHandling();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LevelScene1, [{
    key: "playStartGameVO",
    value: function playStartGameVO(cb) {
      return __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.pth_6b_g1_vo03, cb);
    }
  }, {
    key: "setUpEventHandling",
    value: function setUpEventHandling() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["f" /* ANSWERED */]).throttleTime(500 /* ms */).filter(function () {
        return _this2.timer.value > 0;
      }).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function (_ref) {
        var choice = _ref.choice,
            answer = _ref.answer;


        var isCorrect = _this2.questionController.isCorrect(choice, answer);

        if (isCorrect) {
          _this2.changeGameStateTo(GameState.ANSWER_CORRECT, {});
        } else {
          _this2.changeGameStateTo(GameState.ANSWER_WRONG, {});
        }
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["g" /* NO_LIFE_LEFT */]).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).filter(function () {
        return _this2.timer.value > 0;
      }).subscribe(function () {
        _this2.man.isLoseAndHoldPos = true;
        _this2.changeGameStateTo(GameState.LOSE_GAME, {});
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["h" /* TIMES_UP */]).take(1).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
        _this2.man.isLoseAndHoldPos = true;
        _this2.man.unhappy();
        _this2.changeGameStateTo(GameState.LOSE_GAME, {});
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["i" /* MEET_CHECKPOINT */]).do(function () {
        _this2.currentCheckPoint = _this2.currentCheckPoint + 1;
        if (_this2.currentCheckPoint === GameState.CHECKPOINT_4) {
          _this2.timer.stop();
        }
      }).delay(1500).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).filter(function () {
        return _this2.timer.value > 0;
      }).subscribe(function () {
        //
        _this2.questionBox.disableQuestionBox();
        _this2.changeGameStateTo(_this2.currentCheckPoint, {});
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["j" /* ENABLE_QUESTION_BOX */]).delay(1500).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).filter(function () {
        return _this2.timer.value > 0;
      }).subscribe(function () {
        _this2.questionBox.enableQuestionBox();
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["k" /* STOP_TIMER */]).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
        _this2.timer.stop();
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["e" /* DECREASE_LIFE */]).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).filter(function () {
        return _this2.timer.value > 0;
      }).subscribe(function () {
        _this2.lifeBarController.decrement();
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["l" /* END_GAME */]).take(1).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
        _this2.changeGameStateTo(GameState.PASS_GAME, {});
      });
    }
  }, {
    key: "changeGameStateTo",
    value: function changeGameStateTo(state, data) {
      var _this3 = this;

      if (state === GameState.ANSWER_CORRECT) {
        __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.correct);
        console.log('the answer is correct');
        this.questionBox.disableQuestionBox({ isVisible: true });

        if (!this.questionController.isMeetCheckPoint()) {
          if (!this.questionBox.isLastQuestion()) {
            __WEBPACK_IMPORTED_MODULE_28_rxjs__["Observable"].of(0).delay(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].delay.afterAnswerEachQuestion).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              _this3.questionBox.enableQuestionBox();

              _this3.questionBox.nextQuestion();
            });
          }
        }
      } else if (state === GameState.ANSWER_WRONG) {
        __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.wrong);
        console.log('the answer is wrong');
        this.questionBox.disableQuestionBox();
        this.fireBalls.dropping();
        __WEBPACK_IMPORTED_MODULE_28_rxjs__["Observable"].of(0).delay(1500).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.man.onFire();
        });
      } else if (state === GameState.CHECKPOINT_1) {

        this.chkptArrow1.flashing();

        __WEBPACK_IMPORTED_MODULE_28_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.camel.addOnClickListener(function () {
            _this3.chkptArrow1.remove();
            _this3.camel.carryWalking(500);
          });
        });
      } else if (state === GameState.CHECKPOINT_2) {

        this.chkptArrow2.flashing();

        __WEBPACK_IMPORTED_MODULE_28_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.snake.addOnClickListener(function () {
            _this3.chkptArrow2.remove();
            _this3.flute.jumpIn().takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).do(function () {
              return _this3.snake.looking();
            }).flatMap(function () {
              return _this3.flute.playMusic();
            }).subscribe();
          });
        });
      } else if (state === GameState.CHECKPOINT_3) {

        this.chkptArrow3.flashing();

        __WEBPACK_IMPORTED_MODULE_28_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.stone.addOnClickListener(function () {
            _this3.chkptArrow3.remove();
            _this3.stone.dropping();
          });
        });
      } else if (state === GameState.CHECKPOINT_4) {

        this.chkptArrow4.flashing();

        this.statue.addOnClickListener(function () {

          _this3.chkptArrow4.remove();

          __WEBPACK_IMPORTED_MODULE_28_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).do(function () {
            _this3.door.appear();
            _this3.statue.nodding();
          }).flatMap(function () {
            return _this3.eagle.flyToMan();
          }).flatMap(function () {
            return _this3.key.dropToMan();
          }).do(function () {
            return _this3.key.openDoor();
          }).delay(2000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
            _this3.man.rideOnCamel(_this3.camel, function () {
              _this3.camel.camelWithManWalking(_this3.man, 2000, function () {
                __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["l" /* END_GAME */], {});
              });
            });
          });
        });
      } else if (state === GameState.PASS_GAME) {
        this.timer.stop();
        this.questionBox.disableQuestionBox();

        switch (this.passedLevel) {
          case END_GAME:
            this.endGame();
            break;
          default:
            __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.pass_level1);
            __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.sfx_clap, function () {
              _this3.popUpInfoScene(_this3.resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.success_01.name].texture);
              __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.pth_6b_g1_vo07, function () {
                __WEBPACK_IMPORTED_MODULE_28_rxjs__["Observable"].of(0).delay(4000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
                  _this3.nextScene();
                });
              });
            });
        }
      } else if (state === GameState.LOSE_GAME) {
        this.timer.stop();
        this.questionBox.disableQuestionBox();
        __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.fail_level1, function () {
          _this3.popUpInfoScene(_this3.resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.fail_01.name].texture);
          __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.pth_6b_g1_vo06, function () {
            __WEBPACK_IMPORTED_MODULE_28_rxjs__["Observable"].of(0).delay(4000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              _this3.playAgain();
            });
          });
        });
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.timer.stop();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.removeAll();
      this.timer.stop();
      clearTimeout(this.schedulePlayStartGameVO);
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(LevelScene1.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LevelScene1.prototype), "destroy", this).call(this, { children: true });
    }
  }, {
    key: "backToSelection",
    value: function backToSelection() {
      this.destroy();
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.SELECTION });
    }
  }, {
    key: "playAgain",
    value: function playAgain() {
      this.destroy();
      this.passedLevel = this.passedLevel - 1;
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.LEVEL_1, data: { passedLevel: this.passedLevel } });
    }
  }, {
    key: "popUpInfoScene",
    value: function popUpInfoScene(texture) {
      this.infoScene = new __WEBPACK_IMPORTED_MODULE_34__InfoScene__["a" /* default */](this.resources, texture);
      this.addChild(this.infoScene);
    }
  }, {
    key: "nextScene",
    value: function nextScene() {
      this.destroy();
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.LEVEL_2, data: { passedLevel: this.passedLevel } });
    }
  }, {
    key: "endGame",
    value: function endGame() {
      this.destroy();
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.END_GAME });
    }
  }]);

  return LevelScene1;
}(__WEBPACK_IMPORTED_MODULE_8__objects_Scene__["a" /* default */]);

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LevelScene2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Scene__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_FullScreenBg__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SoundManager__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__objects_Button__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__characters_common_BannerText__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__characters_common_Timer__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__controllers_QuestionController__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__characters_common_QuestionBox__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__controllers_LifeBarController__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__characters_common_Heart__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__characters_common_Man__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__characters_level2_Key__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__characters_common_SpeechBubble__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__characters_common_CheckPointArrow__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__InfoScene__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__characters_common_Door__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__characters_level2_Wood__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__characters_level2_Pecker__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__characters_level2_Indian__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__characters_level2_Beacon__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__characters_level2_BirdTower__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__characters_level2_Arrows__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__characters_level2_Grass__ = __webpack_require__(395);






/**
 * Created by Gaplo917 on 3/9/2017.
 */































var GameState = {
  ANSWER_CORRECT: "ANSWER_1_CORRECT",
  ANSWER_WRONG: "ANSWER_1_WRONG",
  PASS_GAME: "PASS_GAME",
  LOSE_GAME: "LOSE_GAME",
  CHECKPOINT_1: 1,
  CHECKPOINT_2: 2,
  CHECKPOINT_3: 3,
  CHECKPOINT_4: 4
};

var END_GAME = 3;

var LevelScene2 = function (_Scene) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(LevelScene2, _Scene);

  function LevelScene2(resources, settings) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LevelScene2);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LevelScene2.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LevelScene2)).call(this));

    __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.stopBackground();

    _this.resources = resources;
    _this.settings = settings;
    _this.passedLevel = settings.passedLevel + 1;

    var questionController = new __WEBPACK_IMPORTED_MODULE_17__controllers_QuestionController__["a" /* default */](__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].settings.level2Settings);
    questionController.prepareQuestions();

    var hearts = [0, 1, 2].map(function (i) {
      return new __WEBPACK_IMPORTED_MODULE_20__characters_common_Heart__["a" /* default */](i * 120 + 1330, 100, resources);
    });

    var bg = new __WEBPACK_IMPORTED_MODULE_10__objects_FullScreenBg__["a" /* default */](resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.level2_bg.name].texture);
    var grass = new __WEBPACK_IMPORTED_MODULE_35__characters_level2_Grass__["a" /* Grass */](500, 1200, resources);
    var bannerText = new __WEBPACK_IMPORTED_MODULE_15__characters_common_BannerText__["a" /* BannerText */](100, 55, "請判斷哪個量詞用得恰當？", resources);
    var restartBtn = new __WEBPACK_IMPORTED_MODULE_14__objects_Button__["a" /* default */](1940, 1450, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.returnBtn.name].texture);
    var timer = new __WEBPACK_IMPORTED_MODULE_16__characters_common_Timer__["a" /* Timer */](1790, 100, resources);
    var questionBox = new __WEBPACK_IMPORTED_MODULE_18__characters_common_QuestionBox__["a" /* default */](600, 200, questionController.questions, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].settings.level2Settings.level);
    var lifeBarController = new __WEBPACK_IMPORTED_MODULE_19__controllers_LifeBarController__["a" /* default */](hearts, 3);
    var heartBox = new __WEBPACK_IMPORTED_MODULE_21__objects_Image__["a" /* default */](1450, 100, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.heartBox.name].texture);
    var door = new __WEBPACK_IMPORTED_MODULE_28__characters_common_Door__["a" /* Door */](2150, 920, resources);

    // const startptArrow = new CheckPointArrow(600, 300, -2.5, resources[R.images.checkPointArrow.name].texture)
    var chkptArrow1 = new __WEBPACK_IMPORTED_MODULE_26__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](600, 300, -2.5, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);
    var chkptArrow2 = new __WEBPACK_IMPORTED_MODULE_26__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](1480, 200, -2.5, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);
    var chkptArrow3 = new __WEBPACK_IMPORTED_MODULE_26__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](1050, 800, -1.6, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);
    var chkptArrow4 = new __WEBPACK_IMPORTED_MODULE_26__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](750, 950, -1.6, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);

    //animation
    var bubble = new __WEBPACK_IMPORTED_MODULE_25__characters_common_SpeechBubble__["a" /* SpeechBubble */](500, 900, resources);
    var man = new __WEBPACK_IMPORTED_MODULE_22__characters_common_Man__["a" /* Man */](280, 1250, resources);
    var key = new __WEBPACK_IMPORTED_MODULE_23__characters_level2_Key__["a" /* Key */](1300, 1200, resources);
    var wood = new __WEBPACK_IMPORTED_MODULE_29__characters_level2_Wood__["a" /* Wood */](700, 1300, resources);
    var pecker = new __WEBPACK_IMPORTED_MODULE_30__characters_level2_Pecker__["a" /* Pecker */](1760, 500, resources);
    var indian1 = new __WEBPACK_IMPORTED_MODULE_31__characters_level2_Indian__["a" /* Indian */](1300, 1250, resources, true);
    var indian2 = new __WEBPACK_IMPORTED_MODULE_31__characters_level2_Indian__["a" /* Indian */](1600, 1250, resources);
    var indian3 = new __WEBPACK_IMPORTED_MODULE_31__characters_level2_Indian__["a" /* Indian */](1900, 1250, resources);
    var birdTower = new __WEBPACK_IMPORTED_MODULE_33__characters_level2_BirdTower__["a" /* BirdTower */](768, 645, resources);
    var beacon = new __WEBPACK_IMPORTED_MODULE_32__characters_level2_Beacon__["a" /* Beacon */](1130, 576, resources);
    var arrows = new __WEBPACK_IMPORTED_MODULE_34__characters_level2_Arrows__["a" /* Arrows */](2500, -1000, resources);

    _this.addChild(bg);
    _this.addChild(grass);
    _this.addChild(bubble);
    _this.addChild(bannerText);
    _this.addChild(beacon);
    // this.addChild(startptArrow)
    _this.addChild(chkptArrow1);
    _this.addChild(chkptArrow2);
    _this.addChild(chkptArrow3);
    _this.addChild(chkptArrow4);
    _this.addChild(pecker);
    _this.addChild(indian1);
    _this.addChild(indian3);
    _this.addChild(indian2);
    _this.addChild(door);
    _this.addChild(birdTower);
    _this.addChild(key);
    _this.addChild(questionBox);
    _this.addChild(wood);
    _this.addChild(arrows);
    _this.addChild(man);
    _this.addChild(timer);
    _this.addChild(heartBox);
    _this.addChild(restartBtn);
    hearts.forEach(function (_) {
      return _this.addChild(_);
    });

    _this.currentCheckPoint = 0;
    _this.questionBox = questionBox;
    _this.questionController = questionController;
    _this.timer = timer;
    _this.lifeBarController = lifeBarController;
    _this.man = man;
    _this.key = key;
    // this.startptArrow = startptArrow
    _this.chkptArrow1 = chkptArrow1;
    _this.chkptArrow2 = chkptArrow2;
    _this.chkptArrow3 = chkptArrow3;
    _this.chkptArrow4 = chkptArrow4;
    _this.door = door;
    _this.wood = wood;
    _this.pecker = pecker;
    _this.indian1 = indian1;
    _this.indian2 = indian2;
    _this.indian3 = indian3;
    _this.birdTower = birdTower;
    _this.beacon = beacon;
    _this.arrows = arrows;

    _this.schedulePlayStartGameVO = setTimeout(function () {
      _this.playStartGameVO(function () {

        __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playBackground(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.bg_6bg1_bg2);

        var t0 = timer.flashing();
        var t1 = bubble.appear();
        var t2 = bubble.disappear();
        var t3 = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween().onComplete(function () {
          timer.start();
          _this.questionBox.enableQuestionBox();
          // startptArrow.flashing()
          // birdTower.addOnClickListener(() => {
          //   timer.start()
          //   this.questionBox.enableQuestionBox()
          //   startptArrow.remove()
          // })
        });
        t0.chain(t1);
        t1.chain(t2);
        t2.chain(t3);
        t0.start();
      });
    }, 1500);

    restartBtn.displayGroup = new __WEBPACK_IMPORTED_MODULE_6_pixi_js__["DisplayGroup"](9, true);
    restartBtn.addOnClickListener(function () {
      _this.backToSelection();
    });

    _this.setUpEventHandling();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LevelScene2, [{
    key: "playStartGameVO",
    value: function playStartGameVO(cb) {
      return __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.pth_6b_g1_vo04, cb);
    }
  }, {
    key: "setUpEventHandling",
    value: function setUpEventHandling() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["f" /* ANSWERED */]).throttleTime(500 /* ms */).filter(function () {
        return _this2.timer.value > 0;
      }).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function (_ref) {
        var choice = _ref.choice,
            answer = _ref.answer;


        var isCorrect = _this2.questionController.isCorrect(choice, answer);

        if (isCorrect) {
          _this2.changeGameStateTo(GameState.ANSWER_CORRECT, {});
        } else {
          _this2.changeGameStateTo(GameState.ANSWER_WRONG, {});
        }
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["g" /* NO_LIFE_LEFT */]).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).filter(function () {
        return _this2.timer.value > 0;
      }).subscribe(function () {
        _this2.man.isLoseAndHoldPos = true;
        _this2.changeGameStateTo(GameState.LOSE_GAME, {});
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["h" /* TIMES_UP */]).take(1).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
        _this2.man.isLoseAndHoldPos = true;
        _this2.man.unhappy();
        _this2.changeGameStateTo(GameState.LOSE_GAME, {});
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["i" /* MEET_CHECKPOINT */]).do(function () {
        _this2.currentCheckPoint = _this2.currentCheckPoint + 1;
        if (_this2.currentCheckPoint === GameState.CHECKPOINT_4) {
          _this2.timer.stop();
        }
      }).delay(1500).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).filter(function () {
        return _this2.timer.value > 0;
      }).subscribe(function () {
        //
        _this2.questionBox.disableQuestionBox();
        _this2.changeGameStateTo(_this2.currentCheckPoint, {});
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["j" /* ENABLE_QUESTION_BOX */]).delay(2000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).filter(function () {
        return _this2.timer.value > 0;
      }).subscribe(function () {
        _this2.questionBox.enableQuestionBox();
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["k" /* STOP_TIMER */]).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
        _this2.timer.stop();
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["e" /* DECREASE_LIFE */]).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).filter(function () {
        return _this2.timer.value > 0;
      }).subscribe(function () {
        _this2.lifeBarController.decrement();
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["l" /* END_GAME */]).take(1).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
        _this2.changeGameStateTo(GameState.PASS_GAME, {});
      });
    }
  }, {
    key: "changeGameStateTo",
    value: function changeGameStateTo(state, data) {
      var _this3 = this;

      if (state === GameState.ANSWER_CORRECT) {
        __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.correct);
        console.log('the answer is correct');
        this.questionBox.disableQuestionBox({ isVisible: true });

        if (!this.questionController.isMeetCheckPoint()) {
          if (!this.questionBox.isLastQuestion()) {
            __WEBPACK_IMPORTED_MODULE_24_rxjs__["Observable"].of(0).delay(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].delay.afterAnswerEachQuestion).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              _this3.questionBox.enableQuestionBox();
              _this3.questionBox.nextQuestion();
            });
          }
        }
      } else if (state === GameState.ANSWER_WRONG) {
        __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.wrong);
        console.log('the answer is wrong');
        this.questionBox.disableQuestionBox();
        this.arrows.shooting();
        __WEBPACK_IMPORTED_MODULE_24_rxjs__["Observable"].of(0).delay(1500).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.man.onShoot();
        });
      } else if (state === GameState.CHECKPOINT_1) {

        this.chkptArrow1.flashing();

        __WEBPACK_IMPORTED_MODULE_24_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.birdTower.addOnClickListener(function () {
            _this3.chkptArrow1.remove();
            var r0 = _this3.birdTower.rebuild();
            var r1 = _this3.beacon.firing();

            r0.flatMap(function () {
              return r1;
            }).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["j" /* ENABLE_QUESTION_BOX */], {});
            });
          });
        });
      } else if (state === GameState.CHECKPOINT_2) {

        this.chkptArrow2.flashing();

        __WEBPACK_IMPORTED_MODULE_24_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.pecker.addOnClickListener(function () {
            _this3.chkptArrow2.remove();

            var r0 = _this3.pecker.pecking();
            var r1 = _this3.wood.appear();
            var r2 = _this3.wood.peckingByPecker();

            r0.flatMap(function () {
              return r1;
            }).flatMap(function () {
              return r2;
            }).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["j" /* ENABLE_QUESTION_BOX */], {});
            });
          });
        });
      } else if (state === GameState.CHECKPOINT_3) {

        this.chkptArrow3.flashing();

        __WEBPACK_IMPORTED_MODULE_24_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.wood.addOnClickListener(function () {
            _this3.chkptArrow3.remove();

            var r0 = _this3.wood.cutting();
            r0.takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["j" /* ENABLE_QUESTION_BOX */], {});
            });
          });
        });
      } else if (state === GameState.CHECKPOINT_4) {

        this.chkptArrow4.flashing();

        __WEBPACK_IMPORTED_MODULE_24_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.wood.addOnClickListener(function () {
            _this3.chkptArrow4.remove();

            _this3.indian1.happy();
            _this3.indian2.happy();
            _this3.indian3.happy();

            _this3.key.openDoor().takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe();

            var r0 = _this3.wood.onFire();
            var r1 = _this3.door.appearing();
            var r2 = _this3.man.walking();

            r0.flatMap(function () {
              return r1;
            }).delay(2000).flatMap(function () {
              return r2;
            }).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["l" /* END_GAME */], {});
            });
          });
        });
      } else if (state === GameState.PASS_GAME) {
        this.timer.stop();
        this.questionBox.disableQuestionBox();

        switch (this.passedLevel) {
          case END_GAME:
            this.endGame();
            break;
          default:
            __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.sfx_clap);
            __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.pass_level2, function () {
              _this3.popUpInfoScene(_this3.resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.success_02.name].texture);
              __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.pth_6b_g1_vo09, function () {
                __WEBPACK_IMPORTED_MODULE_24_rxjs__["Observable"].of(0).delay(4000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
                  _this3.nextScene();
                });
              });
            });
        }
      } else if (state === GameState.LOSE_GAME) {
        this.timer.stop();
        this.questionBox.disableQuestionBox();
        __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.fail_level1, function () {
          _this3.popUpInfoScene(_this3.resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.fail_02.name].texture);
          __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.pth_6b_g1_vo08, function () {
            __WEBPACK_IMPORTED_MODULE_24_rxjs__["Observable"].of(0).delay(4000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              _this3.playAgain();
            });
          });
        });
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.timer.stop();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.removeAll();
      this.timer.stop();
      clearTimeout(this.schedulePlayStartGameVO);
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(LevelScene2.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LevelScene2.prototype), "destroy", this).call(this, { children: true });
    }
  }, {
    key: "backToSelection",
    value: function backToSelection() {
      this.destroy();
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.SELECTION });
    }
  }, {
    key: "playAgain",
    value: function playAgain() {
      this.destroy();
      this.passedLevel = this.passedLevel - 1;
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.LEVEL_2, data: { passedLevel: this.passedLevel } });
    }
  }, {
    key: "popUpInfoScene",
    value: function popUpInfoScene(texture) {
      this.infoScene = new __WEBPACK_IMPORTED_MODULE_27__InfoScene__["a" /* default */](this.resources, texture);
      this.addChild(this.infoScene);
    }
  }, {
    key: "nextScene",
    value: function nextScene() {
      this.destroy();
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.LEVEL_3, data: { passedLevel: this.passedLevel } });
    }
  }, {
    key: "endGame",
    value: function endGame() {
      this.destroy();
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.END_GAME });
    }
  }]);

  return LevelScene2;
}(__WEBPACK_IMPORTED_MODULE_8__objects_Scene__["a" /* default */]);

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LevelScene3; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__objects_Scene__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__objects_FullScreenBg__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Events__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SoundManager__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__objects_Button__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__characters_common_BannerText__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__characters_common_Timer__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__controllers_QuestionController__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__characters_common_QuestionBox__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__controllers_LifeBarController__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__characters_common_Heart__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__objects_Image__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__characters_common_Man__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__characters_common_SpeechBubble__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__characters_common_CheckPointArrow__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InfoScene__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__characters_common_Door__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__characters_level3_Owl__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__characters_level3_Tortoise__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__characters_level3_TreeStick__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__characters_level3_BigStone__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__characters_level3_Spider__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__characters_level3_WoodBox__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__characters_level3_Crocodile__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__characters_level3_Rock__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__objects_TimeBar__ = __webpack_require__(409);






/**
 * Created by Gaplo917 on 3/9/2017.
 */
































var GameState = {
  ANSWER_CORRECT: "ANSWER_1_CORRECT",
  ANSWER_WRONG: "ANSWER_1_WRONG",
  PASS_GAME: "PASS_GAME",
  LOSE_GAME: "LOSE_GAME",
  CHECKPOINT_1: 1,
  CHECKPOINT_2: 2,
  CHECKPOINT_3: 3,
  CHECKPOINT_4: 4
};

var END_GAME = 3;

var LevelScene3 = function (_Scene) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(LevelScene3, _Scene);

  function LevelScene3(resources, settings) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LevelScene3);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LevelScene3.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LevelScene3)).call(this));

    __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.stopBackground();

    _this.resources = resources;
    _this.settings = settings;
    _this.passedLevel = settings.passedLevel + 1;

    var questionController = new __WEBPACK_IMPORTED_MODULE_17__controllers_QuestionController__["a" /* default */](__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].settings.level3Settings);
    questionController.prepareQuestions();

    var bg = new __WEBPACK_IMPORTED_MODULE_10__objects_FullScreenBg__["a" /* default */](resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.level3_bg.name].texture);
    var river = function () {
      var img = new __WEBPACK_IMPORTED_MODULE_21__objects_Image__["a" /* default */](1024, 1300, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.river.name].texture);
      img.alpha = 0.7;
      return img;
    }();
    var timeBar = new __WEBPACK_IMPORTED_MODULE_36__objects_TimeBar__["a" /* TimeBar */](100, 55, resources);
    var restartBtn = new __WEBPACK_IMPORTED_MODULE_14__objects_Button__["a" /* default */](1940, 1450, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.returnBtn.name].texture);
    var timer = new __WEBPACK_IMPORTED_MODULE_16__characters_common_Timer__["a" /* Timer */](1790, 100, resources);
    var questionBox = new __WEBPACK_IMPORTED_MODULE_18__characters_common_QuestionBox__["a" /* default */](600, 200, questionController.questions, resources, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].settings.level3Settings.level);
    var door = new __WEBPACK_IMPORTED_MODULE_27__characters_common_Door__["a" /* Door */](2150, 920, resources);

    // const startptArrow = new CheckPointArrow(500, 620, 0.5, resources[R.images.checkPointArrow.name].texture)
    var chkptArrow1 = new __WEBPACK_IMPORTED_MODULE_25__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](500, 620, 0.5, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);
    var chkptArrow2 = new __WEBPACK_IMPORTED_MODULE_25__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](1270, 160, -2.5, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);
    var chkptArrow3 = new __WEBPACK_IMPORTED_MODULE_25__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](1550, 750, -2.5, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);
    var chkptArrow4 = new __WEBPACK_IMPORTED_MODULE_25__characters_common_CheckPointArrow__["a" /* CheckPointArrow */](100, 1380, 1.5, resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.checkPointArrow.name].texture);

    //animation
    var bubble = new __WEBPACK_IMPORTED_MODULE_24__characters_common_SpeechBubble__["a" /* SpeechBubble */](600, 900, resources);
    var man = new __WEBPACK_IMPORTED_MODULE_22__characters_common_Man__["a" /* Man */](300, 1190, resources);
    var owl = new __WEBPACK_IMPORTED_MODULE_28__characters_level3_Owl__["a" /* Owl */](100, 350, resources);
    var tortoise1 = new __WEBPACK_IMPORTED_MODULE_29__characters_level3_Tortoise__["a" /* Tortoise */](2048 + 200, 1300, resources);
    var tortoise2 = new __WEBPACK_IMPORTED_MODULE_29__characters_level3_Tortoise__["a" /* Tortoise */](2048 + 400, 1280, resources);
    var tortoise3 = new __WEBPACK_IMPORTED_MODULE_29__characters_level3_Tortoise__["a" /* Tortoise */](2048 + 600, 1250, resources);
    var treeStick = new __WEBPACK_IMPORTED_MODULE_30__characters_level3_TreeStick__["a" /* TreeStick */](1500, 385, resources);
    var bigStone = new __WEBPACK_IMPORTED_MODULE_31__characters_level3_BigStone__["a" /* BigStone */](1742, 160, resources);
    var spider = new __WEBPACK_IMPORTED_MODULE_32__characters_level3_Spider__["a" /* Spider */](120, 570, resources);
    var woodBox = new __WEBPACK_IMPORTED_MODULE_33__characters_level3_WoodBox__["a" /* WoodBox */](1830, 1000, resources);
    var crocodile = new __WEBPACK_IMPORTED_MODULE_34__characters_level3_Crocodile__["a" /* Crocodile */](700, 1450, resources);
    var rock = new __WEBPACK_IMPORTED_MODULE_35__characters_level3_Rock__["a" /* Rock */](2200, 1250, resources);

    _this.addChild(bg);
    _this.addChild(bubble);
    _this.addChild(owl);
    _this.addChild(woodBox);
    _this.addChild(tortoise1);
    _this.addChild(tortoise2);
    _this.addChild(tortoise3);
    _this.addChild(treeStick);
    _this.addChild(door);
    _this.addChild(questionBox);
    // this.addChild(startptArrow)
    _this.addChild(chkptArrow1);
    _this.addChild(chkptArrow2);
    _this.addChild(chkptArrow3);
    _this.addChild(chkptArrow4);
    _this.addChild(crocodile);
    _this.addChild(bigStone);
    _this.addChild(river);
    _this.addChild(spider);
    _this.addChild(man);
    _this.addChild(rock);
    _this.addChild(restartBtn);
    _this.addChild(timeBar);
    _this.addChild(timer);

    _this.currentCheckPoint = 0;
    _this.questionBox = questionBox;
    _this.questionController = questionController;
    _this.score = timer;
    _this.timeBar = timeBar;
    _this.man = man;
    // this.startptArrow = startptArrow
    _this.chkptArrow1 = chkptArrow1;
    _this.chkptArrow2 = chkptArrow2;
    _this.chkptArrow3 = chkptArrow3;
    _this.chkptArrow4 = chkptArrow4;
    _this.door = door;
    _this.owl = owl;
    _this.tortoise1 = tortoise1;
    _this.tortoise2 = tortoise2;
    _this.tortoise3 = tortoise3;
    _this.treeStick = treeStick;
    _this.bigStone = bigStone;
    _this.spider = spider;
    _this.woodBox = woodBox;
    _this.crocodile = crocodile;
    _this.rock = rock;

    _this.scheduleStartGame = setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playBackground(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.bg_6bg1_bg3);

      var t0 = timer.flashing();
      var t1 = bubble.appear();
      var t2 = bubble.disappear();
      var t3 = new __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.Tween().onComplete(function () {
        timeBar.start(__WEBPACK_IMPORTED_MODULE_6_pixi_js__["ticker"].shared, __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].settings.common.timer);
        _this.questionBox.enableQuestionBox();
      });
      t0.chain(t1);
      t1.chain(t2);
      t2.chain(t3);
      t0.start();
    }, 1500);

    restartBtn.displayGroup = new __WEBPACK_IMPORTED_MODULE_6_pixi_js__["DisplayGroup"](9, true);
    restartBtn.addOnClickListener(function () {
      _this.backToSelection();
    });

    _this.setUpEventHandling();

    // for dev
    // this.changeGameStateTo(4, {})
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LevelScene3, [{
    key: "playStartGameVO",
    value: function playStartGameVO(cb) {
      return __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.pth_6b_g1_vo05, cb);
    }
  }, {
    key: "setUpEventHandling",
    value: function setUpEventHandling() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["f" /* ANSWERED */]).throttleTime(500 /* ms */).filter(function () {
        return _this2.timeBar.value > 0.2;
      }).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function (_ref) {
        var choice = _ref.choice,
            answer = _ref.answer;


        var isCorrect = _this2.questionController.isCorrect(choice, answer);

        if (isCorrect) {
          _this2.changeGameStateTo(GameState.ANSWER_CORRECT, {});
        } else {
          _this2.changeGameStateTo(GameState.ANSWER_WRONG, {});
        }
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["g" /* NO_LIFE_LEFT */]).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).filter(function () {
        return _this2.timeBar.value > 0.2;
      }).subscribe(function () {
        _this2.man.isLoseAndHoldPos = true;
        _this2.changeGameStateTo(GameState.LOSE_GAME, {});
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["h" /* TIMES_UP */]).take(1).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
        _this2.man.isLoseAndHoldPos = true;
        _this2.man.unhappy();
        _this2.changeGameStateTo(GameState.LOSE_GAME, {});
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["i" /* MEET_CHECKPOINT */]).do(function () {
        _this2.currentCheckPoint = _this2.currentCheckPoint + 1;
        if (_this2.currentCheckPoint === GameState.CHECKPOINT_4) {
          _this2.timeBar.stop();
        }
      }).delay(1500).filter(function () {
        return _this2.timeBar.value > 0.2;
      }).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
        _this2.questionBox.disableQuestionBox();
        _this2.changeGameStateTo(_this2.currentCheckPoint, {});
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["j" /* ENABLE_QUESTION_BOX */]).delay(1500).filter(function () {
        return _this2.timeBar.value >= 1;
      }).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
        _this2.questionBox.enableQuestionBox();
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["k" /* STOP_TIMER */]).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
        _this2.timeBar.stop();
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["e" /* DECREASE_LIFE */]).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).filter(function () {
        return _this2.timeBar.value > 0.2;
      }).subscribe(function () {
        _this2.timeBar.deductTime(10);
        __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["j" /* ENABLE_QUESTION_BOX */], {});
      });

      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["l" /* END_GAME */]).take(1).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
        _this2.changeGameStateTo(GameState.PASS_GAME, {});
      });
    }
  }, {
    key: "changeGameStateTo",
    value: function changeGameStateTo(state, data) {
      var _this3 = this;

      if (state === GameState.ANSWER_CORRECT) {
        __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.correct);
        console.log('the answer is correct');
        this.score.addScore();
        this.questionBox.disableQuestionBox({ isVisible: true });

        if (!this.questionController.isMeetCheckPoint()) {
          if (!this.questionBox.isLastQuestion()) {
            __WEBPACK_IMPORTED_MODULE_23_rxjs__["Observable"].of(0).delay(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].delay.afterAnswerEachQuestion).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["j" /* ENABLE_QUESTION_BOX */], {});
              _this3.questionBox.nextQuestion();
            });
          }
        }
      } else if (state === GameState.ANSWER_WRONG) {
        __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.wrong);
        console.log('the answer is wrong');
        this.questionBox.disableQuestionBox();
        this.rock.dropping();

        __WEBPACK_IMPORTED_MODULE_23_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.wrong_ans_eff_3);
          _this3.man.getRollByStone();
        });
      } else if (state === GameState.CHECKPOINT_1) {

        this.chkptArrow1.flashing();

        __WEBPACK_IMPORTED_MODULE_23_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.owl.addOnClickListener(function () {
            //remove arrow
            _this3.chkptArrow1.remove();

            var r1 = _this3.owl.wakeUp();

            r1.takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["j" /* ENABLE_QUESTION_BOX */], {});
            });
          });
        });
      } else if (state === GameState.CHECKPOINT_2) {

        this.chkptArrow2.flashing();

        __WEBPACK_IMPORTED_MODULE_23_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.treeStick.addOnClickListener(function () {
            //remove arrow
            _this3.chkptArrow2.remove();

            var r0 = _this3.owl.flyingToWoodStick().do(function () {
              return _this3.removeChild(_this3.treeStick);
            });
            var r12 = __WEBPACK_IMPORTED_MODULE_23_rxjs__["Observable"].combineLatest(_this3.owl.flyWithStick(_this3.treeStick), _this3.bigStone.rolling());
            var r3 = _this3.crocodile.stunning();
            var r4 = _this3.bigStone.sinking();
            var r5 = _this3.crocodile.sinking();

            r0.flatMap(function () {
              return r12;
            }).flatMap(function () {
              return r3;
            }).delay(100).flatMap(function () {
              return r4;
            }).flatMap(function () {
              return r5;
            }).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["j" /* ENABLE_QUESTION_BOX */], {});
            });
          });
        });
      } else if (state === GameState.CHECKPOINT_3) {

        this.chkptArrow3.flashing();

        __WEBPACK_IMPORTED_MODULE_23_rxjs__["Observable"].of(0).delay(1000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
          _this3.woodBox.addOnClickListener(function () {
            //remove arrow
            _this3.chkptArrow3.remove();

            __WEBPACK_IMPORTED_MODULE_23_rxjs__["Observable"].of(0).delay(5200).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.level3_turtle);
            });

            var r0 = _this3.tortoise1.walking(5000, 400).flatMap(function () {
              return _this3.tortoise1.retracting();
            });
            var r1 = _this3.tortoise2.walking(6666, 0).flatMap(function () {
              return _this3.tortoise2.retracting();
            });
            var r2 = _this3.tortoise3.walking(8333, -400).flatMap(function () {
              return _this3.tortoise3.retracting();
            });
            var combine = __WEBPACK_IMPORTED_MODULE_23_rxjs__["Observable"].combineLatest(r0, r1, r2);

            combine.subscribe(function () {
              __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["j" /* ENABLE_QUESTION_BOX */], {});
            });
          });
        });
      } else if (state === GameState.CHECKPOINT_4) {

        this.chkptArrow4.flashing();

        this.spider.addOnClickListener(function () {
          _this3.chkptArrow4.remove();

          var r2 = _this3.spider.putTheKeyInNet();
          var r3 = _this3.door.appearing();
          var r4 = _this3.spider.openDoor();
          var r5 = _this3.man.walking();

          r2.flatMap(function () {
            return r3;
          }).flatMap(function () {
            return r4;
          }).delay(500).do(function () {
            setTimeout(function () {
              return __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.sfx_clap, 1000);
            });
          }).flatMap(function () {
            return r5;
          }).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
            __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["l" /* END_GAME */], {});
          });
        });
      } else if (state === GameState.PASS_GAME) {
        this.timeBar.stop();
        this.questionBox.disableQuestionBox();
        this.endGame();
      } else if (state === GameState.LOSE_GAME) {
        this.timeBar.stop();
        this.questionBox.disableQuestionBox();
        __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.fail_level1, function () {
          _this3.popUpInfoScene(_this3.resources[__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].images.fail_03.name].texture);
          __WEBPACK_IMPORTED_MODULE_13__SoundManager__["a" /* default */].instance.playEffect(__WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].sounds.game_feedback_bad, function () {
            __WEBPACK_IMPORTED_MODULE_23_rxjs__["Observable"].of(0).delay(4000).takeUntil(__WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].getEventStream(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */])).subscribe(function () {
              _this3.playAgain();
            });
          });
        });
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.timeBar.stop();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      __WEBPACK_IMPORTED_MODULE_7__tweenjs_tween_js___default.a.removeAll();
      this.timeBar.stop();
      clearTimeout(this.scheduleStartGame);
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(LevelScene3.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LevelScene3.prototype), "destroy", this).call(this, { children: true });
    }
  }, {
    key: "backToSelection",
    value: function backToSelection() {
      this.destroy();
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.SELECTION });
    }
  }, {
    key: "playAgain",
    value: function playAgain() {
      this.destroy();
      this.passedLevel = this.passedLevel - 1;
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.LEVEL_3, data: { passedLevel: this.passedLevel } });
    }
  }, {
    key: "popUpInfoScene",
    value: function popUpInfoScene(texture) {
      this.infoScene = new __WEBPACK_IMPORTED_MODULE_26__InfoScene__["a" /* default */](this.resources, texture);
      this.addChild(this.infoScene);
    }
  }, {
    key: "nextScene",
    value: function nextScene() {
      this.destroy();
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.END_GAME });
    }
  }, {
    key: "endGame",
    value: function endGame() {
      this.destroy();
      __WEBPACK_IMPORTED_MODULE_11__Events__["a" /* hub */].publishEvent(__WEBPACK_IMPORTED_MODULE_11__Events__["c" /* NEXT_SCENE */], { scene: __WEBPACK_IMPORTED_MODULE_9__config_R__["a" /* default */].scenes.END_GAME });
    }
  }]);

  return LevelScene3;
}(__WEBPACK_IMPORTED_MODULE_8__objects_Scene__["a" /* default */]);

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LevelScene1__ = __webpack_require__(412);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LevelScene1__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LevelScene2__ = __webpack_require__(413);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__LevelScene2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LevelScene3__ = __webpack_require__(414);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__LevelScene3__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EndGameScene__ = __webpack_require__(411);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__EndGameScene__["a"]; });
/**
 * Created by Gaplo917 on 3/9/2017.
 */





/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(375);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by Gaplo917 on 9/7/2017.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  textStyles: {
    chinese: function chinese(fontSize) {
      return {
        fontFamily: 'EPHKaiHK-Medium',
        fontSize: fontSize
      };
    },
    pinyin: function pinyin(fontSize) {
      return {
        fontFamily: 'EPH_PINYIN',
        fontSize: fontSize
      };
    },
    timer: function timer(fontSize) {
      return {
        fontFamily: 'Arial',
        fontSize: fontSize
      };
    }
  },
  scenes: {
    START: 1,
    SELECTION: 2,
    LEVEL_1: 3,
    LEVEL_2: 4,
    LEVEL_3: 5,
    END_GAME: 6
  },
  dimen: {
    width: 1024 * 2,
    height: 768 * 2
  },
  settings: {
    common: {
      timer: 225,
      totalCorrectQuestions: 12,
      totalQuestions: 35
    },
    level1Settings: {
      level: 'level1'
    },
    level2Settings: {
      level: 'level2'
    },
    level3Settings: {
      level: 'level3'
    }
  },
  images: {
    initBg: { name: 'initBg', src: 'static/img/index_bg.png' },
    startBtn: { name: 'startBtn', src: 'static/img/btn_start.png' },
    selectStageBg: { name: 'selectStageBg', src: 'static/img/selection_bg.png' },
    startGame: { name: 'startGame', src: 'static/img/start_game.png' },
    tipsBtn: { name: 'tipsBtn', src: 'static/img/btn_tips.png' },
    returnBtn: { name: 'returnBtn', src: 'static/img/home_btn-21.png' },
    btnLevel1: { name: 'btnLevel1', src: 'static/img/btn_level1.png' },
    btnLevel2: { name: 'btnLevel2', src: 'static/img/btn_level2.png' },
    btnLevel3: { name: 'btnLevel3', src: 'static/img/btn_level3.png' },
    timerBox: { name: 'timerBox', src: 'static/img/timer_box.png' },
    checkPointArrow: { name: 'checkPointArrow', src: 'static/img/check_point_arrow.png' },
    infoBg: { name: 'infoBg', src: 'static/img/info_bg.png' },
    success_01: { name: 'success_01', src: 'static/img/success_01.png' },
    success_02: { name: 'success_02', src: 'static/img/success_02.png' },
    success_03: { name: 'success_03', src: 'static/img/success_03.png' },
    fail_01: { name: 'fail_01', src: 'static/img/fail_01.png' },
    fail_02: { name: 'fail_02', src: 'static/img/fail_02.png' },
    fail_03: { name: 'fail_03', src: 'static/img/fail_03.png' },
    end: { name: 'end', src: 'static/img/end.png' },
    selectionBtnPlay: { name: 'selection_btn_PLAY', src: 'static/img/selection_btn_PLAY.png' },
    selectionBtnRE: { name: 'selection_btn_RE', src: 'static/img/selection_btn_RE.png' },

    // LEVEL 1
    level1Bg1: { name: 'level1Bg1', src: 'static/img/level1_bg_g1.png' },
    level1Bg2: { name: 'level1Bg2', src: 'static/img/level1_bg_g2.png' },
    questionBox: { name: 'questionBox', src: 'static/img/question_box.png' },
    level1Choice1: { name: 'level1Choice1', src: 'static/img/level1_choice1.png' },
    level1Choice2: { name: 'level1Choice2', src: 'static/img/level1_choice2.png' },
    heart: { name: 'heart', src: 'static/img/heart.png' },
    heartEmpty: { name: 'heartEmpty', src: 'static/img/heart_empty.png' },
    heartBox: { name: 'heartBox', src: 'static/img/heart_box.png' },
    key: { name: 'key', src: 'static/img/key.png' },
    lizard: { name: 'lizard', src: 'static/img/lizard.png' },
    speechBubble: { name: 'speechBubble', src: 'static/img/speech_bubble.png' },
    stone: { name: 'stone', src: 'static/img/stone.png' },
    door_01: { name: 'door_01', src: 'static/img/door_01.png' },
    door_02: { name: 'door_02', src: 'static/img/door_02.png' },
    arrow: { name: 'arrow', src: 'static/img/arrow.png' },
    fireball: { name: 'fireball', src: 'static/img/fireball.png' },

    // LEVEL 2
    level2_bg: { name: 'level2_bg', src: 'static/img/level2_bg.png' },
    level2Choice1: { name: 'level2Choice1', src: 'static/img/level2_choice1.png' },
    level2Choice2: { name: 'level2Choice2', src: 'static/img/level2_choice2.png' },
    column01: { name: 'column01', src: 'static/img/column01.png' },
    column02: { name: 'column02', src: 'static/img/column02.png' },
    column03: { name: 'column03', src: 'static/img/column03.png' },
    beaconBack: { name: 'beaconBack', src: 'static/img/fenghuotai_1.png' },
    beaconFront: { name: 'beaconFront', src: 'static/img/fenghuotai_0.png' },

    // LEVLE 3
    level3_bg: { name: 'level3_bg', src: 'static/img/level3_bg.png' },
    river: { name: 'river', src: 'static/img/river.png' },
    level3Choice1: { name: 'level3Choice1', src: 'static/img/level3_choice1.png' },
    level3Choice2: { name: 'level3Choice2', src: 'static/img/level3_choice2.png' },
    big_stone: { name: 'big_stone', src: 'static/img/big_stone.png' },
    small_wooden: { name: 'small_wooden', src: 'static/img/small_wooden.png' },
    cobweb: { name: 'cobweb', src: 'static/img/cobweb.png' },
    timeBar: { name: 'Time_B', src: 'static/img/Time_B.png' },
    clock: { name: 'clock', src: 'static/img/clock.png' },

    end_game_bg: { name: 'end_game_bg', src: 'static/img/end_game_bg.png' },

    // End Game
    map: { name: 'map', src: 'static/img/ditu.png' }
  },
  sounds: {
    game_feedback_bad: {
      src: ['static/sound/game_feedback_bad.mp3'],
      volume: 1
    },
    game_feedback_good: {
      src: ['static/sound/game_feedback_good.mp3'],
      volume: 1
    },
    pth_6bs2_p52_ga_01: {
      src: ['static/sound/pth_6bs2_p52_ga_01.mp3'],
      volume: 1
    },
    pth_6bs2_p52_ga_02: {
      src: ['static/sound/pth_6bs2_p52_ga_02.mp3'],
      volume: 1
    },
    bg_6bg1_bg1: {
      //背景音樂
      src: ['static/sound/CORP56.mp3'],
      volume: 0.2,
      loop: true
    },
    bg_6bg1_bg2: {
      //背景音樂
      src: ['static/sound/ADVENT08.mp3'],
      volume: 0.2,
      loop: true
    },
    bg_6bg1_bg3: {
      //背景音樂
      src: ['static/sound/CORP04.mp3'],
      volume: 0.2,
      loop: true
    },

    click1: {
      //表示在本關要找出一條鎖匙，配聲效1
      src: ['static/sound/CLICK1.mp3'],
      volume: 1
    },
    d: {
      //時限倒數音效
      src: ['static/sound/fx04.mp3'],
      volume: 1
    },
    correct: {
      //答對聲效
      src: ['static/sound/E023.mp3'],
      volume: 1
    },
    wrong: {
      //答錯聲效
      src: ['static/sound/wrong.mp3'],
      volume: 1
    },
    pass_level1: {
      //過關音樂1
      src: ['static/sound/E027.mp3'],
      volume: 1
    },
    fail_level1: {
      //過關失敗音樂
      src: ['static/sound/S063.mp3'],
      volume: 1
    },
    pass_level2: {
      //過關音樂1
      src: ['static/sound/COM01.mp3'],
      volume: 1
    },

    wrong_ans_eff_1: {
      //畫面上方降下許多火球
      src: ['static/sound/missile_sfx.mp3'],
      volume: 1
    },
    wrong_ans_eff_2: {
      //畫面射出許多箭
      src: ['static/sound/arrow2.mp3'],
      volume: 1
    },
    wrong_ans_eff_3: {
      //畫面左邊出現大石碌出
      src: ['static/sound/Sfx_drop.mp3'],
      volume: 1
    },

    sfx_clap: {
      //完成遊戲 λ	拍手音效
      src: ['static/sound/sfx_clap.mp3'],
      volume: 1
    },
    pth_6b_g1_vo01: {
      //野外歷險記
      src: ['static/sound/pth_6b_g1_vo01.mp3'],
      volume: 1
    },
    pth_6b_g1_vo02: {
      //請選擇一個地方開始你的歷險旅程吧！
      src: ['static/sound/pth_6b_g1_vo02.mp3'],
      volume: 1
    },
    pth_6b_g1_vo03: {
      //請判斷哪個是普通話詞語？
      src: ['static/sound/pth_6b_g1_vo03.mp3'],
      volume: 1
    },
    pth_6b_g1_vo04: {
      //請判斷哪個量詞用得恰當？
      src: ['static/sound/pth_6b_g1_vo04.mp3'],
      volume: 1
    },
    pth_6b_g1_vo05: {
      //請判斷哪句話符合普通話的語法？
      src: ['static/sound/pth_6b_g1_vo05.mp3'],
      volume: 1
    },
    pth_6b_g1_vo06: {
      //失敗：這次做得不太好，沒關係，再試試看吧！
      src: ['static/sound/pth_6b_g1_vo06.mp3'],
      volume: 1
    },
    pth_6b_g1_vo07: {
      //成功：真棒！請你繼續接受挑戰吧！
      src: ['static/sound/pth_6b_g1_vo07.mp3'],
      volume: 1
    },
    pth_6b_g1_vo08: {
      //失敗：這次做得不太好，沒關係，再試試看吧！
      src: ['static/sound/pth_6b_g1_vo08.mp3'],
      volume: 1
    },
    pth_6b_g1_vo09: {
      //成功：真棒！請你繼續接受挑戰吧！
      src: ['static/sound/pth_6b_g1_vo09.mp3'],
      volume: 1
    },
    pth_6b_g1_vo10: {
      //失敗：這次做得不太好，沒關係，再試試看吧！
      src: ['static/sound/pth_6b_g1_vo10.mp3'],
      volume: 1
    },
    pth_6b_g1_vo11: {
      //遊戲結束：真棒！你做得非常好！
      src: ['static/sound/pth_6b_g1_vo11.mp3'],
      volume: 1
    },

    level1_donkey: {
      //驢叫（給蛇嚇倒）
      src: ['static/sound/LV1_donkey.mp3'],
      volume: 1
    },
    level1_dropstone: {
      //
      src: ['static/sound/LV1_dropstone.mp3'],
      volume: 1
    },
    level1_flute: {
      src: ['static/sound/LV1_flute.mp3'],
      volume: 1
    },
    level1_nod: {
      //頭像移動
      src: ['static/sound/LV1_nod.mp3'],
      volume: 1
    },
    level2_fire: {
      //
      src: ['static/sound/LV2_fire.mp3'],
      volume: 1
    },
    level2_movestone: {
      //
      src: ['static/sound/LV2_movestone.mp3'],
      volume: 1
    },
    level2_movewood: {
      //
      src: ['static/sound/LV2_movewood.mp3'],
      volume: 1
    },
    level2_woodpecker: {
      //
      src: ['static/sound/LV2_woodpecker.mp3'],
      volume: 1
    },
    level3_dropapple: {
      //
      src: ['static/sound/LV3_dropapple.mp3'],
      volume: 1
    },
    level3_flapwings: {
      //
      src: ['static/sound/LV3_flapwings.mp3'],
      volume: 1
    },
    level3_splash: {
      //
      src: ['static/sound/LV3_splash.mp3'],
      volume: 1
    },
    level3_turtle: {
      //
      src: ['static/sound/LV3_turtle.mp3'],
      volume: 1
    }
  },
  string: {},
  spines: {
    snake: {
      id: 'she',
      json: 'static/spine/she.json',
      timeScale: 0.7,
      animations: {
        looking: 'run',
        stop: 'stop'
      }
    },
    camel: {
      id: 'luotuo',
      json: 'static/spine/luotuo.json',
      timeScale: 0.6,
      animations: {
        winking: 'Idle',
        walking: 'walk2',
        frighten: 'shoujing',
        protagonist: 'chipingguo',
        carryWalk: 'walk'
      }
    },
    eagle: {
      id: 'ying',
      json: 'static/spine/ying.json',
      timeScale: 0.5,
      animations: {
        flyingWithoutKey: 'walk2',
        flyingWithKey: 'walk',
        dropKey: 'diaoyaoshi'
      }
    },
    statue: {
      id: 'shixiang',
      json: 'static/spine/shixiang.json',
      timeScale: 0.7,
      animations: {
        nodding: 'shixiangyaotou'
      }
    },
    man: {
      id: 'xiaoyeren2',
      json: 'static/spine/xiaoyeren2.json',
      timeScale: 1,
      animations: {
        winking: 'stop',
        walking: 'run',
        ride: 'qicheng',
        hitOnFire: 'hit',
        hitByBow: 'hit2',
        hitByStone: 'hit3',
        pickingUp: 'jianditu',
        jump: 'jump'
      }
    },
    flute: {
      id: 'dizi',
      json: 'static/spine/dizi.json',
      timeScale: 0.5,
      animations: {
        animation: { track: 1, name: 'animation' }
      }
    },

    grass: {
      id: 'cao',
      json: 'static/spine/level2/cao.json',
      timeScale: 1,
      animations: {
        animation: 'animation'
      }
    },
    indian: {
      id: 'static/spine/level2/xiaoren2.json',
      json: 'static/spine/level2/xiaoren2.json',
      timeScale: 1,
      animations: {
        animation: 'animation',
        happy: 'jumubang'
      }
    },
    indianWithKey: {
      id: 'static/spine/level2/xiaoren.json',
      json: 'static/spine/level2/xiaoren.json',
      timeScale: 1,
      animations: {
        animation: 'animation',
        happy: 'jumubang'
      }
    },
    birdTower: {
      id: 'tuteng',
      json: 'static/spine/level2/tuteng.json',
      timeScale: 0.34,
      animations: {
        animation: 'animation'
      }
    },
    pecker: {
      id: 'zhuomuniao',
      json: 'static/spine/level2/zhuomuniao.json',
      timeScale: 1,
      animations: {
        idle: 'zhayan',
        peck: 'zhuomu'
      }
    },

    preFire: {
      id: 'huodui2',
      json: 'static/spine/level2/huodui2.json',
      timeScale: 0.5,
      animations: {
        settingWood: 'huodui',
        idleWood: 'huodui2',
        makingFire: 'huodui1'
      }
    },
    fire: {
      id: 'huo',
      json: 'static/spine/level2/huo.json',
      timeScale: 0.8,
      animations: {
        fire: 'animation'
      }
    },
    axeWood: {
      id: 'pimutou',
      json: 'static/spine/level2/pimutou.json',
      timeScale: 0.3,
      animations: {
        beforeAxe: 'mutou',
        axe: 'pimutou'

      }
    },
    beacon: {
      id: 'fenghuotai',
      json: 'static/spine/level2/fenghuotai.json',
      timeScale: 1,
      animations: {
        animation: 'animation'
      }
    },

    crocodile: {
      id: 'eyu',
      json: 'static/spine/level3/eyu.json',
      timeScale: 1,
      animations: {
        idle: 'daiji',
        dead: 'shitouzhuan'
      }
    },
    tortoise: {
      id: 'level3/wugui',
      json: 'static/spine/level3/wugui.json',
      timeScale: 1,
      animations: {
        idle: 'daiji',
        retracting: 'suoke',
        walking: 'zou'
      }
    },
    owl: {
      id: 'level3/maotouying',
      json: 'static/spine/level3/maotouying.json',
      timeScale: 1,
      animations: {
        idleWaked: 'daiji',
        idleSleeping: 'shuijiao',
        flying: 'maotouyingfei',
        flyingWithStick: 'daizoushuzhi',
        hitByApple: 'pingguozatou'
      }
    },
    spider: {
      id: 'level3/zhizhu',
      json: 'static/spine/level3/zhizhu.json',
      timeScale: 0.6,
      animations: {
        idle: 'daiji',
        animation: 'zhizhuwangshangpa'
      }
    },
    woodBox: {
      id: 'level3/muxiang',
      json: 'static/spine/level3/muxiang.json',
      timeScale: 1,
      animations: {
        idle: 'daiji',
        open: 'dakai'
      }
    }
  },
  spriteSheets: {},
  vos: {

    /* dynamic inject in loadVO, just provide some schema*/
    vo: {
      src: [],
      volume: 1
    }
  },
  question: {
    /* dynamic inject, just provide some schema*/
    level1: [{ "choice1": "奶酪", "choice2": "芝士", "answer": "奶酪" }],
    level2: [{ "choice1": "一間學校", "choice2": "一所學校", "answer": "一所學校" }],
    level3: [{ "choice1": "多吃一點兒吧！", "choice2": "吃多些啦！", "answer": "多吃一點兒吧！" }]
  },
  delay: {
    afterAnswerEachQuestion: 2000
  }
});

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_R__ = __webpack_require__(5);





/**
 * Created by Gaplo917 on 9/7/2017.
 */



var Button = function (_PIXI$Sprite) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Button, _PIXI$Sprite);

  function Button(x, y, texture) {
    var rolloverEffect = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Button);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Button.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Button)).call(this, texture));

    _this.anchor.x = 0.5;
    _this.anchor.y = 0.5;
    _this.x = x;
    _this.y = y;
    _this.rolloverEffect = rolloverEffect;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Button, [{
    key: "addOnClickListener",
    value: function addOnClickListener(fn) {
      var _this2 = this;

      this.interactive = true;
      this.buttonMode = true;

      this.on('mousedown', function () {
        _this2.touchEffect(true);
      }).on('mouseup', function (e) {
        _this2.touchEffect(false);
      }).on('mouseover', function () {
        if (_this2.rolloverEffect) {
          _this2.touchEffect(true);
        }
      }).on('mouseout', function () {
        _this2.touchEffect(false);
      }).on('touchstart', function () {
        _this2.touchEffect(true);
      }).on('touchend', function () {
        _this2.touchEffect(false);
      }).on('touchendoutside', function (e) {
        _this2.touchEffect(false);
      }).on('touchcancel', function (e) {
        _this2.touchEffect(false);
      }).on('touchend', function (e) {
        _this2.touchEffect(false);
      }).on('tap', function (e) {
        fn(e);
      }).on('click', function (e) {
        fn(e);
      });
    }
  }, {
    key: "touchEffect",
    value: function touchEffect() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (enabled) {
        this.alpha = 0.7;
      } else {
        this.alpha = 1.0;
      }
    }
  }, {
    key: "removeOnClickListener",
    value: function removeOnClickListener() {
      this.interactive = false;
      this.buttonMode = false;

      this.removeListener('mousedown').removeListener('touchstart').removeListener('mouseup').removeListener('touchend');
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_5_pixi_js__["Sprite"]);

/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pixi_js__);




/**
 * Created by Gaplo917 on 10/7/2017.
 */


// just extends for a better class name

var Scene = function (_PIXI$Container) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Scene, _PIXI$Container);

  function Scene() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Scene);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Scene.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Scene)).call(this));
  }

  return Scene;
}(__WEBPACK_IMPORTED_MODULE_4_pixi_js__["Container"]);

/* harmony default export */ __webpack_exports__["a"] = (Scene);

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_R__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__tweenjs_tween_js__);




/**
 * Created by Gaplo917 on 9/7/2017.
 */




var FullScreenBg = function (_PIXI$Sprite) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(FullScreenBg, _PIXI$Sprite);

  function FullScreenBg(texture) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FullScreenBg);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FullScreenBg.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(FullScreenBg)).call(this, texture));

    _this.setTransform(0, 0, __WEBPACK_IMPORTED_MODULE_5__config_R__["a" /* default */].dimen.width / _this.width, __WEBPACK_IMPORTED_MODULE_5__config_R__["a" /* default */].dimen.height / _this.height);
    return _this;
  }

  return FullScreenBg;
}(__WEBPACK_IMPORTED_MODULE_4_pixi_js__["Sprite"]);

/* harmony default export */ __webpack_exports__["a"] = (FullScreenBg);

/***/ })

},[416]);


// WEBPACK FOOTER //
// static/js/app.bedc90399442388386a7.js